export const ru_strings = {
  'smartTable.requestReason': 'Причина запроса',
  'smartTable.passportType': 'Тип паспорта',
  'err.pattern.^0[1-9]\\d{6,14}$': 'Номер должен начинаться с 0, за которым следует цифра от 1 до 9, а затем от 6 до 14 цифр.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': 'Поле "{fieldName}" может содержать только буквы, акценты, пробелы, апострофы, точки и дефисы.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': 'Поле "{fieldName}" может содержать только буквы, цифры, акценты, пробелы, дефисы, точки, апострофы и скобки.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': 'Поле "{fieldName}" может содержать только буквы, цифры, акценты, пробелы, апострофы, точки, скобки и дефисы.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': 'Поле "{fieldName}" может содержать только буквы, цифры, акценты, пробелы, апострофы, запятые, точки, скобки и дефисы.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': 'Поле "{fieldName}" может содержать только буквы, цифры, акценты, пробелы, апострофы, точки, скобки и дефисы.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': 'Поле "{fieldName}" может содержать только буквы, цифры, акценты, пробелы, апострофы, точки, скобки и дефисы.',
  'tooltip.allNotes': 'Просмотреть все заметки',
  'tooltip.openDuplicate': 'Открыть последний дубликат платежа',
  'payment.openDuplicate': 'Открыть дубликат',
  'err.pattern.password': 'Пароль должен содержать как минимум два из следующих типов символов: строчную букву, прописную букву, цифру или специальный символ.',
  'form.perm1.DYN.': 'Создать приложение',
  'global.pay': 'Оплатить',
  'smartTable.timeslot': 'Временной интервал',
  'refusalReason.desc.DYN.': '<p>Пожалуйста, укажите краткое описание причины отказа.</p>',
  'timezone.notice': 'Записи планируются в соответствии с часовым поясом места проведения встречи.',
  'timeslot.noBooking': 'Бронирование временного слота не было сделано.',
  'timeslot.tooCloseToChange': 'Вы больше не можете изменить эту встречу, так как она назначена менее чем через {hours} часов.',
  'session.inactive.title': '"Сеанс неактивен',
  'session.inactive': 'Ваш сеанс истёк из-за бездействия.',
  'reactivateSession': 'Возобновить сеанс',
  'global.changeTimeSlot': 'Изменить время',
  'BirthCity': 'Город рождения',
  'outUsage.AB': 'Это заявление <b>вышло из срока своей действительности</b>. Пожалуйста, направьте заявителя к терминалу или помогите ему подать новую заявку.',
  'outUsage.C': 'Это заявление <b>вышло из срока своей действительности</b>. Пожалуйста, закройте эту заявку, затем создайте новую запись для заявителя и продолжите с отказом.',
  'err.payment.notAvailable': 'Эта заявка не доступна.',
  'form.PlaceOfBirth': 'Место рождения',
  'borderPass': 'Пограничный пропуск',
  'urgent_pass': 'Срочный паспорт',
  'feedback': 'Обратная связь',
  'err.mustBeDifferentThan.errorValue': 'Поле "{fieldName}" должно быть отлично от {errorValue}.',
  'DYN.PASSPORT_WRONG': 'Неверный тип паспорта',
  'err.max.errorValue': 'Поле "{fieldName}" должно быть меньше {errorValue}.',
  'err.max': 'Поле «{fieldName}» должно быть меньше максимально допустимого значения.',
  'err.min.errorValue': 'Поле "{fieldName}" должно быть больше {errorValue}.',
  'err.min': 'Поле «{fieldName}» должно быть больше минимально допустимого значения.',
  'updateField.desc': 'Пожалуйста, предоставьте обновленную информацию для следующего поля: <b>{field}</b>',
  'marital.status.engaged': 'Женат/Замужем',
  'place.notExist': 'Место не существует',
  'ApplicationForm': 'Форма заявления',
  'BirthCertificate': 'Свидетельство о рождении',
  'ParentalAuthorization': 'Родительское разрешение',
  'printSettings.selected': 'Вы изменяете настройки печати для документа: <b>{documentName}</b>',
  'print.settings.success': 'Настройки печати были успешно обновлены для документа: <b>{documentName}</b>',
  'error.noHasFace': 'На фотографии не обнаружено лицо. Пожалуйста, сделайте фото заново.',
  'name.warn': 'Имя и/или фамилия пустые или содержат менее 2 символов.',
  'kiosk.redirect': 'Ваша национальность не позволяет продолжить работу в режиме киоска. Пожалуйста, войдите в систему с учетной записью для продолжения. Вы будете перенаправлены на экран входа',
  'err.OtherPurpose.required': 'Поле "Другая причина" обязательно для заполнения',
  'print.qr.verification': 'Проверка',
  'print.qr.application': 'Заявление',
  'print.terms': 'Применяются условия и положения.',
  'movements.empty': 'Движения пока не зарегистрированы.',
  'movement.history': 'История въезда/выезда',
  'payment.notes': 'Заметки',
  'payment.noNotes': 'Нет доступных заметок',
  'extension.alreadyExists.warning': 'Для данного запроса уже существует продление. Вы уверены, что хотите создать новое?',
  'payment.addNote.placeholder': 'Добавить заметку…',
  'payment.addNote.success': 'Заметка успешно добавлена.',
  'global.seeMore': 'Показать больше',
  'global.seeLess': 'Показать меньше',
  'downgrade.type.label': 'Тип целевой визы',
  'smartTable.timeslotPlaceId': 'Место временного интервала',
  'ask.downgradeType': 'Выберите тип целевой визы',
  'err.approveRefuse.required': 'Пожалуйста, выберите, хотите ли вы рекомендовать или нет.',
  'ask.downgrade.multiple': 'Вы уверены, что хотите понизить этот визу до {type}?',
  'err.hostPhone.pattern': 'Номер телефона должен начинаться с + (кода страны) или 0 и содержать от 7 до 15 цифр.',
  'reprintSticker': 'Повторная печать стикера',
  'PreviousVisa': 'Предыдущая виза',
  'err.PreviousVisa.required': 'Предыдущая виза обязательна',
  'multipleEntry.warning': 'Внимание: визы с множественным въездом предоставляются только лицам, которые ранее получили хотя бы одну действительную визу. Потребуется копия предыдущей визы.',
  'err.daysGranted.max': 'Количество дней не может превышать запрошенное количество дней.',
  'err.daysGranted.min': 'Количество дней должно быть не менее 1.',
  'err.daysGranted.required': 'Количество дней обязательно.',
  'approval.daysGranted.error': 'Пожалуйста, введите допустимое количество дней.',
  'err.password.pattern': 'Пароль должен содержать как минимум два из следующих типов символов: строчную букву, прописную букву, цифру или специальный символ.',
  'err.documentNumber.pattern': 'Номер документа должен содержать только буквы, цифры, пробелы и дефисы.',
  'err.ExistingValidEntryReference.required': 'Существующая действительная ссылка на въезд обязательное поле',
  'ask.borderpass': 'Это действительно пограничный пропуск?',
  'BirthCountry': 'Гражданство',
  'old': 'Старый пароль',
  'firstName': 'Имя',
  'email': 'Email',
  'paymentMethod': 'Метод оплаты',
  'client.extended.softLockedOutLogin30Minutes': 'Вы были заблокированы на 30 минут. Пожалуйста, попробуйте еще раз позже.',
  'password': 'Пароль',
  'password2': 'Подтвердить пароль',
  'PreviousConvictions': 'Осуждены за преступление в Кот-д\'Ивуаре',
  'Address': 'Адрес',
  'err.err': 'Ошибка',
  'err.minDateMilliFromNow.errorValue': 'Поле "{fieldName}" должно содержать дату, не раньше {errorValue}.',
  'err.maxDateMilliFromNow.errorValue': 'Поле "{fieldName}" должно содержать дату, не позже {errorValue}.',
  'err.minDateMilliFromNow': 'Поле "{fieldName}" должно содержать дату, не раньше минимально допустимой.',
  'err.maxDateMilliFromNow': 'Поле "{fieldName}" должно содержать дату, не позже максимально допустимой.',
  'err.mustMatch': 'Поле {fieldName} должно совпадать с соответствующим полем.',
  'err.requireOneOf.errorValue': '{errorValue} должны быть предоставлены',
  'err.requireOneOf.field': 'Поле \'{name}\'',
  'err.requireOneOf.separator': ' или ',
  'err.pattern.^[0-9]{6,14}$': 'Поле "{fieldName}" должно содержать от 6 до 14 цифр.',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': 'Поле "{fieldName}" должно содержать от 3 до 15 символов: буквы, цифры, пробелы или дефисы.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'Поле "{fieldName}" должно содержать от 7 до 20 символов: цифры, пробелы, дефисы или скобки.',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'Поле "{fieldName}" должно содержать от 5 до 20 букв или цифр.',
  'err.pattern.^[0-9]{10}$': 'Поле "{fieldName}" должно содержать ровно 10 цифр.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'Поле "{fieldName}" должно содержать от 5 до 20 буквенно-цифровых символов.',
  'err.pattern.^[0-9]{8,20}$': 'Поле "{fieldName}" должно содержать от 8 до 20 цифр.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'Поле "{fieldName}" должно содержать от 5 до 15 буквенно-цифровых символов.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'Поле "{fieldName}" должно содержать изображение JPEG или JP2 в допустимом формате, закодированное в base64.',
  'err.pattern.^[a-z]$': 'Поле "{fieldName}" должно содержать одну строчную букву.',
  "err.pattern.^[A-Z' -]*$": 'Поле "{fieldName}" может содержать только заглавные буквы, апострофы, пробелы и дефисы.',
  'err.pattern.^[0-9-]{6,15}$': 'Поле "{fieldName}" должно содержать от 6 до 15 символов (только цифры и дефисы).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'Поле "{fieldName}" должно содержать действительный адрес электронной почты.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'Поле "{fieldName}" должно содержать изображение (JPEG, PNG, WebP) или PDF-файл в допустимом формате, закодированное в base64.',
  'err.pattern.^[A-Z]{3}$': 'Поле "{fieldName}" должно содержать ровно три заглавные буквы.',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'Поле "{fieldName}" должно содержать корректный номер телефона, с кодом страны или без, допускаются пробелы, дефисы и точки.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'Поле "{fieldName}" должно содержать корректный международный или национальный номер телефона (например: +1234567890 или 0123456789).',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'Поле "{fieldName}" может содержать только буквы, пробелы и дефисы.',
  "err.pattern.^[a-zA-Z' -]*$": 'Поле "{fieldName}" может содержать только буквы, пробелы и дефисы.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'Поле "{fieldName}" может содержать только буквы, цифры, пробелы и дефисы.',
  'err.pattern.^[0-9]*$': 'Поле "{fieldName}" должно содержать только цифры.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'Поле "{fieldName}" должно содержать дату.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'Поле "{fieldName}" должно начинаться с заглавной буквы и может содержать строчные буквы, акценты, пробелы, апострофы, дефисы или точки.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'Поле "{fieldName}" должно содержать только буквы (с акцентами или без), пробелы, апострофы, дефисы или точки.',
  'err.pattern.^[A-Z0-9]+$': 'Поле "{fieldName}" должно содержать только заглавные буквы и цифры.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'Поле "{fieldName}" должно начинаться с "+" и содержать от 1 до 4 цифр (первый символ не может быть 0).',
  'err.required': 'Поле "{fieldName}" обязательно для заполнения.',
  'err.maxlength.errorValue': 'Поле "{fieldName}" может содержать не более {errorValue} символов.',
  'err.minlength.errorValue': 'Поле "{fieldName}" должно содержать не менее {errorValue} символов.',
  'err.maxlength': 'Поле "{fieldName}" слишком длинное.',
  'err.minlength': 'Поле "{fieldName}" слишком короткое.',
  'err.pattern': 'Поле "{fieldName}" имеет недопустимый формат.',
  'err.email': 'Поле "{fieldName}" должно содержать корректный адрес электронной почты.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'Бронирование подтверждено!',
  'global.bookTimeSlot': 'Забронировать временной слот',
  'client.extended.maxMonthlyPaymentsReached': 'Вы достигли максимального количества ежемесячных платежей. Пожалуйста, обратитесь в службу поддержки.',
  'calendar.weekday.sunday': 'Вс',
  'calendar.weekday.monday': 'Пн',
  'calendar.weekday.tuesday': 'Вт',
  'calendar.weekday.wednesday': 'Ср',
  'calendar.weekday.thursday': 'Чт',
  'calendar.weekday.friday': 'Пт',
  'calendar.weekday.saturday': 'Сб',
  'calendar.month.january': 'Январь',
  'calendar.month.february': 'Февраль',
  'calendar.month.march': 'Март',
  'calendar.month.april': 'Апрель',
  'calendar.month.may': 'Май',
  'calendar.month.june': 'Июнь',
  'calendar.month.july': 'Июль',
  'calendar.month.august': 'Август',
  'calendar.month.september': 'Сентябрь',
  'calendar.month.october': 'Октябрь',
  'calendar.month.november': 'Ноябрь',
  'calendar.month.december': 'Декабрь',
  'calendar.timeline.no_slots': 'Нет доступных временных слотов на этот день',
  'calendar.timeline.available': 'Доступно',
  'calendar.timeline.spots_available': 'мест доступно',
  'calendar.timeline.fully_booked': 'Полностью забронировано',
  'calendar.confirm_booking_title': 'Подтвердить бронирование',
  'calendar.confirm_booking_message': 'Пожалуйста, подтвердите, что вы хотите забронировать этот временной слот.',
  'calendar.booking_in_progress': 'Бронирование в процессе...',
  'calendar.please_wait': 'Пожалуйста, подождите, пока мы обрабатываем ваше бронирование.',
  'calendar.booking_error_title': 'Ошибка бронирования',
  'calendar.booking_success_title': 'Бронирование подтверждено!',
  'calendar.booking_success_message': 'Ваш временной слот был успешно забронирован.',
  'calendar.proceed_to_payment': 'Перейти к оплате',
  'calendar.auto_proceed_message': 'Автоматическое перенаправление через...',
  'calendar.date': 'Дата',
  'calendar.time': 'Время',
  'calendar.place': 'Место',
  'calendar.loading_month': 'Загрузка доступности...',
  'extension.error.maxDays': 'Вы не можете запросить более 30 дней за одно продление.',
  'DYN.processed.NOTICES_ACCEPTED': 'Уведомления подтверждены',
  'notices_validated': 'Уведомления подтверждены',
  'err.daysUntilReport.pattern': 'Количество дней до отчета должно иметь правильный формат',
  'err.reportInterval.pattern': 'Интервал отчета должен быть числом больше или равно 0',
  'err.CompanionsSize.min': 'Количество сопровождающих должно быть не менее 1',
  'err.CompanionsSize.max': 'Количество сопровождающих слишком длинное',
  'global.error': 'Произошла ошибка. Пожалуйста, попробуйте еще раз. Если проблема не решится, обратитесь в службу поддержки.',
  'err.DurationOfStay.required': 'Длительность пребывания обязательное поле',
  'err.DurationOfStay.min': 'Длительность пребывания должна быть не менее 1 дня',
  'err.DurationOfStay.max': 'Длительность пребывания слишком длинная',
  'DurationOfStay': 'Длительность пребывания (дней)',
  'tooltip.acceptNotices': 'Подтвердить текущие уведомление',
  'notices': 'Уведомления',
  'ask.notices': 'Вы хотите подтвердить уведомление?',
  'accept.notices': 'Подтвердить уведомление',
  'err.ModeOfTravel.required': 'Тип транспорта обязательное поле',
  'err.FlightNumber.required': 'Номер рейса обязательное поле',
  'err.ShipNumber.required': 'Номер судна обязательное поле',
  'err.CarNumber.required': 'Номер автомобиля обязательное поле',
  'err.BusNumber.required': 'Номер автобуса обязательное поле',
  'err.TrainNumber.required': 'Номер поезда обязательное поле',
  'err.FlightNumber.pattern': 'Номер рейса должен иметь правильный формат',
  'err.ShipNumber.pattern': 'Номер судна должен иметь правильный формат',
  'err.CarNumber.pattern': 'Номер автомобиля должен иметь правильный формат',
  'err.BusNumber.pattern': 'Номер автобуса должен иметь правильный формат',
  'err.TrainNumber.pattern': 'Номер поезда должен иметь правильный формат',
  'ModeOfTravel': 'Тип транспорта',
  'FlightNumber': 'Номер рейса',
  'ShipNumber': 'Номер судна',
  'CarNumber': 'Номер автомобиля',
  'BusNumber': 'Номер автобуса',
  'TrainNumber': 'Номер поезда',
  'DYN.flight': 'Самолёт',
  'DYN.ship': 'Судно',
  'DYN.car': 'Автомобиль',
  'DYN.bus': 'Автобус',
  'DYN.train': 'Поезд',
  'DYN.foot': 'Пешком',
  'expiredSinceTime': 'Заявка истекла <b>{days} дней и {hours} часов назад</b>.',
  'err.placeId.minlength': 'Идентификатор местоположения должен содержать минимум 2 символа',
  'err.name.minlength': 'Имя должно содержать минимум 2 символа',
  'err.email.minlength': 'Электронная почта должна содержать минимум 4 символа',
  'err.passportNumber.maxlength': 'Номер паспорта должен быть длиной менее 50 символов',
  'err.passportNumber.minlength': 'Номер паспорта должен содержать минимум 3 символа',
  'err.lastName.minlength': 'Фамилия должна содержать минимум 3 символа',
  'err.firstName.minlength': 'Имя должно содержать минимум 3 символа',
  'err.batchId.maxlength': 'Ссылка на заявку должна быть длиной менее 50 символов',
  'err.batchId.minlength': 'Ссылка на заявку должна содержать не менее 3 символов',
  'err.nationality.maxlength': 'Гражданство должно быть длиной менее 50 символов',
  'err.nationality.minlength': 'Гражданство должно содержать не менее 3 символов',
  'err.internalReference.minlength': 'Ссылка HQ должна содержать не менее 3 символов',
  'err.internalReference.maxlength': 'Ссылка HQ должна содержать менее 50 символов',
  'smartTable.filter.sinceDays': 'Поскольку',
  'smartTable.filter.createAtStart': 'Дата (начало)',
  'smartTable.filter.createAtEnd': 'Дата (конец)',
  'smartTable.filter.timeslotStart': 'Временной слот (начало)',
  'smartTable.filter.timeslotEnd': 'Временной слот (конец)',
  'smartTable.filter.paymentExtStatus': 'Состояние расширения',
  'smartTable.filter.paymentStatus': 'Состояние заявки',
  'smartTable.filter.overstay': 'Превышение срока пребывания',
  'smartTable.filter.isUrgent': 'Срочный',
  'smartTable.filter.applicationType': 'Тип заявки',
  'smartTable.operationId': 'Тип документа',
  'smartTable.usageUntil': 'Действителен до',
  'smartTable.usageAfter': 'Действителен с',
  'smartTable.price': 'Цена',
  'smartTable.paymentStatus': 'Статус оплаты',
  'smartTable.isUrgent': 'Срочный',
  'smartTable.passportNumber': 'Номер паспорта',
  'smartTable.fullName': 'Полное имя',
  'smartTable.lastName': 'Фамилия',
  'smartTable.firstName': 'Имя',
  'smartTable.batchId': 'Ссылка на заявку',
  'smartTable.nationality': 'Гражданство',
  'smartTable.internalReference': 'Ссылка HQ',
  'smartTable.lock': 'Блокировка',
  'smartTable.applicationId': 'Идентификатор заявки',
  'smartTable.creationDate': 'Дата создания',
  'smartTable.email': 'Электронная почта',
  'smartTable.role': 'Роль',
  'smartTable.name': 'Имя',
  'smartTable.userId': 'Идентификатор пользователя',
  'smartTable.id': 'ИД',
  'smartTable.placeId': 'Идентификатор расположения',
  'total': 'Общее',
  'onlyFinalReview': 'Этот запрос ожидает окончательного рассмотрения.',
  'tooltip.consumeOfficer.OUT': 'Сотрудник, оформивший выход человека.',
  'tooltip.consumeOfficer.IN': 'Сотрудник, оформивший вход человека.',
  'DYN.document.OTHER': 'Документ',
  'DYN.document.IR': 'Разрешение на жительство',
  'DYN.document.D': 'Водитель',
  'DYN.document.ID': 'Удостоверение личности',
  'DYN.document.P': 'Паспорт',
  'scanned': 'Сканировано',
  'DYN.form.documentNumber.scanned': 'Номер {document}',
  'ask.isExtension.confirm': 'Подтверждаете ли вы, что оплата была произведена? Если подтверждаете, пожалуйста, введите реквизиты платежа, способ оплаты и валюту, использованную для платежа.',
  'payment_status.desc.DYN.8.review': 'Это заявление на визу в настоящее время ожидает проверки надзирателем.',
  'payment_status.DYN.8.review': 'Ожидает проверки',
  'DYN.role.5': 'Киоск',
  'DYN.role.4': 'Реестр партнёров',
  'DYN.role.3': 'Администратор',
  'DYN.role.2': 'Потребитель Orbis',
  'DYN.role.1': 'Сотрудник',
  'DYN.role.0': 'Клиент',
  'DYN.role.6': 'Внешний Наблюдатель',
  'info.readingPayment': 'Чтение подробной информации с сервера...',
  'info.searchingPayment': 'Поиск приложения на серверах...',
  'info.convertingImage': 'Конвертация изображения, считанного из документа...',
  'info.disconnect': 'Отключение...',
  'info.readingDG': 'Чтение групп данных...',
  'info.doingPA': 'Выполняется пассивная аутентификация...',
  'info.readingCertificate': 'Чтение сертификата подписания...',
  'info.testingBAC': 'Выполнение базового контроля доступа (BAC)...',
  'info.connecting': 'Подключение к чипу...',
  'info.readingMrz': 'Чтение MRZ...',
  'info.testingReaderCard': 'Проверка наличия чипированной карты у читателя...',
  'info.testingReader': 'Проверка наличия читателя...',
  'tooltip.prepareLandingVisa': 'Подготовить визу по прибытии',
  'printEventsCollapse': 'Все печатные события этого приложения',
  'tooltip.printEvents': 'Список всех печатных событий этого приложения',
  'approval.daysGranted.DYN.': 'Количество предоставленных дней',
  'ask.closeApplication': 'Это действие можно использовать, когда путешественник может предоставить доказательства того, что операция была выполнена офлайн, что позволит считать этот запрос завершенным и удалить его. Пожалуйста, подтвердите, что вы хотите закрыть этот запрос. Это действие окончательно и не может быть отменено.',
  'done.closeApplication': 'Приложение было успешно закрыто. Хотите создать новое приложение на основе этого?',
  'documents.load': 'Загрузить все документы',
  'documents.add': 'Добавить недостающий документ',
  'print.extension': 'Печать продления',
  'open.visaReference': 'Открыть связанное заявление',
  'error.updatePassport': 'Произошла ошибка при обновлении приложения. Пожалуйста, попробуйте еще раз.',
  'supervision.catC.ordinary.refuse': 'ВЪЕЗД ЗАПРЕЩЕН',
  'supervision.catC.ordinary.entry': 'Регистрация заезда',
  'ExistingValidEntryReference': 'Существующая действительная ссылка на въезд',
  'existingValidEntryReference.desc': 'Это приложение содержит <b>действительную ссылку на запись</b>. Это означает, что путешественник уже оплатил и получил разрешение на въезд. Пожалуйста, убедитесь в достоверности ссылки перед продолжением. Если все верно, вы можете продолжить с регистрацией.',
  'no.must_pay': 'Оплата всё ещё требуется',
  'continue': 'Продолжить',
  'global.changePassword': 'Изменить пароль',
  'signIn.forgotPassword': 'Забыли пароль',
  'signIn.title': 'Войти',
  'global.notAccount': 'Еще нет аккаунта?',
  'global.continue': 'Продолжить',
  'Occupation': 'Род деятельности',
  'signUp.title': 'Создать аккаунт',
  'DYN.selectedPaymentMethod.VISA': 'Вы выбрали оплату с помощью <b>Visa</b>.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'Вы выбрали оплату с помощью <b>Mastercard</b>.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'Вы выбрали оплату с помощью <b>American Express</b>.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'Вы выбрали оплату с помощью <b>Diner\'s Club</b>.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'Вы выбрали оплату с помощью <b>Union Pay</b>.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'Вы выбрали оплату с помощью <b>Zimswitch</b>.',
  'DYN.selectedPaymentMethod.PAYPAL': 'Вы выбрали оплату с помощью <b>PayPal</b>.',
  'DYN.selectedPaymentMethod.DISCOVER': 'Вы выбрали оплату с помощью <b>Discover</b>.',
  'ProvisionnalEntryPort': 'Желаемый пункт регистрации',
  'payment_status.desc.offlineApplication': 'Это приложение в настоящее время обрабатывается <b>ОФФЛАЙН</b>. Продолжите процесс, который будет отправлен в очередь синхронизации после завершения.',
  'warn.payment.offlineApplication.quit': 'Вы собираетесь покинуть процесс офлайн-приложения. Вы уверены, что хотите продолжить?<br><br><b>Все данные будут потеряны.</b>',
  'consumeMode.transit': 'Вы сейчас находитесь в <b>режиме транзита</b>, заявки будут автоматически <b>обрабатываться как на въезд, так и на выезд одновременно</b>. Этот режим используется для путешественников, находящихся в транзите и не нуждающихся в пребывании в стране.',
  'no_apply.overstay': 'Без платы',
  'apply.overstay': 'Применить сборы',
  'paymentExtension.overstay': 'Это заявление в настоящее время находится в состоянии просрочки пребывания.<br><br><strong>Базовая цена продления:</strong> {basePrice}<br><strong>Штраф за просрочку:</strong> {penalty}<br><strong>Итого со штрафом:</strong> {totalPrice}<br><br>Вы можете выбрать, следует ли применять плату за просрочку или нет.',
  'clear.storage.tooltip': 'Очистите все локально хранящиеся данные приложения',
  'clear.storage': 'Очистить хранилище',
  'ask.clear.storage': '<b>Это действие выполнит полную очистку данных сайта, аналогично функции "Очистить данные сайта" в Chrome.</b><br>Это очистит: localStorage, sessionStorage, IndexedDB, Cache Storage, Service Workers, Cookies и другие хранилища браузера. Все данные, которые все еще находятся в очереди, будут загружены в файл JSON перед удалением.<br><br>Вы уверены, что хотите продолжить?',
  'download.logs.tooltip': 'Скачайте полные журналы необычных онлайн- и офлайн-активностей. Этот файл будет загружен в формате JSON и主要用于 debugging (отладки) целей.',
  'download.logs': 'Загрузить журналы',
  'scan.noExitFound.wrongPassportType': 'Для этого человека найдена одна или несколько записей со статусом "Готов к выезду", но тип паспорта не соответствует отсканированному документу.<br> <b>Пожалуйста, создайте новый выход для этого человека.</b>',
  'scan.noEntryFound.wrongPassportType': 'Для этого человека найдена одна или несколько записей со статусом "Готов к регистрации", но тип паспорта не соответствует отсканированному документу.<br> <b>Пожалуйста, создайте новую запись для этого человека.</b>',
  'customerName': 'Имя клиента',
  'printEvent.desc': 'Данное заявление на визу было распечатано со всеми сопутствующими документами {date} пользователем',
  'time.year': '{value} год',
  'time.months': '{value} месяцев',
  'time.month': '{value} месяц',
  'time.weeks': '{value} недель',
  'time.week': '{value} неделя',
  'time.days': '{value} дней',
  'time.day': '{value} день',
  'print.alreadyPrinted': 'Документы этой заявки в последний раз были напечатаны пользователем {user} в {date}. Хотите напечатать их снова?',
  'approval.daysGranted.limit': 'Количество предоставленных дней не может превышать запрошенные {days} дней.',
  'paymentUntil.gracePeriod': 'Ниже приведенное приложение в настоящее время находится в периоде грации, который завершается <b>{date}</b>. <br><br> Вы можете решить, должен ли применяться штраф за превышение срока.',
  'payment.consume.placeNotAllowed': 'Эта заявка не может быть обработана в данном месте. Путешественник должен отправиться в одно из следующих мест: <br><b>{places}</b>',
  'tooltip.externalIndexedData': 'Для этой личности найдены несколько паспортов.',
  'visaDocumentsMaxTotalSize': 'Общий размер загруженных документов превышает максимально допустимый размер {size} МБ. Пожалуйста, уменьшите размер документов и повторите попытку.',
  'global.connection.timeout': 'Подключение было прервано. Проверьте подключение к Интернету и попробуйте снова.',
  'help': 'Помощь',
  'unlimited': 'Неограниченный',
  'application.placeAllowed': '<b>ОГРАНИЧЕНИЕ МЕСТОПОЛОЖЕНИЯ:</b> Этот документ может быть обработан только в следующих местах: <b>{places}</b>',
  'transactionReference.alt': 'Ссылка на транзакцию',
  'paymentType.alt': 'Тип оплаты',
  'changeGender.ask': 'Пол в заявке должен быть изменен на Мужской или Женский.',
  'print.askMultiple': 'Хотите распечатать все связанные документы?',
  'application.id': 'ID заявки',
  'printSticker': 'Распечатать визу',
  'correctionFields': 'Следующие поля были исправлены:',
  'corrected.desc': 'Эта заявка была исправлена заявителем {date}.',
  'recentlyCorrected': 'Исправлено',
  'visaValidFrom': 'Виза действует с',
  'visaValidUntil': 'Виза действует до',
  'online': 'Онлайн',
  'offline': 'Офлайн',
  'tooltip.delayed': 'Этот запрос задержан.',
  'movement.tooltip': 'Просмотреть детали перемещений заявки.',
  'issuingOfficer.alt': 'Ответственный офицер',
  'placeOfIssue': 'Место выдачи',
  'tooltip.hasBeenCorrected': 'Эта заявка была исправлена заявителем.',
  'tooltip.extendStay': 'Продлить пребывание заявителя',
  'decisionLetter.title': 'Официальное письмо о визовом решении',
  'decisionLetter.approval.title': 'Заявление на визу одобрено',
  'decisionLetter.refusal.title': 'Заявление на визу отклонено',
  'decisionLetter.applicationId': 'ID заявления',
  'decisionLetter.approvalDate': 'Дата одобрения',
  'decisionLetter.refusalDate': 'Дата отказа',
  'decisionLetter.dear': 'Уважаемый(ая)',
  'decisionLetter.applicant': 'Заявитель',
  'decisionLetter.documentType.application': 'Заявление на визу',
  'decisionLetter.documentType.extension': 'Продление пребывания',
  'decisionLetter.approval.body1': 'Ваше заявление на визу одобрено.',
  'decisionLetter.approval.body2': 'Пожалуйста, предъявите прилагаемый QR-код по прибытии в пункт пропуска (PoE).',
  'decisionLetter.refusal.body1': 'Ваше заявление на визу не было одобрено.',
  'decisionLetter.refusal.body2': 'При необходимости вы можете подать новое заявление, устранив все причины, которые могли привести к отказу.',
  'decisionLetter.signature': 'От имени Генерального директора по вопросам иммиграции.',
  'printApprovalLetter': 'Распечатать письмо с одобрением',
  'operation.REFUSEOUT': 'Отказ в выезде',
  'operation.REFUSEIN': 'Отказ во въезде',
  'error.closeApplication': 'Произошла ошибка при закрытии заявки. Попробуйте еще раз.',
  'closeApplication': 'Отметить как закрытую',
  'tooltip.closeApplication': 'Отметить заявку как закрытую. Это действие необратимо.',
  'understand': 'Понимаю',
  'ExtraDocument1': 'Дополнительный документ №1',
  'ExtraDocument2': 'Дополнительный документ №2',
  'ExtraDocument3': 'Дополнительный документ №3',
  'ExtraDocument4': 'Дополнительный документ №4',
  'ExtraDocument5': 'Дополнительный документ №5',
  'paperSize': 'Ширина бумаги',
  'change_lang': 'Изменить язык',
  'queue.export.desc': 'Хотите экспортировать текущую очередь в файл JSON? <b>Ваша локальная очередь будет удалена после экспорта</b>. Вы уверены, что хотите продолжить?',
  'queue.export': 'Экспортировать в JSON',
  'queue.import': 'Импортировать очередь из JSON',
  'nationality': 'Национальность',
  'gender': 'Пол',
  'HQReference': 'Ссылка HQ',
  'global.resetDefaults': 'Сбросить до значений по умолчанию',
  'shortcuts.desc': 'Вы можете задать собственные сочетания клавиш ниже. Нажмите на клавишу, для которой хотите задать новое сочетание, и нажмите нужную клавишу на клавиатуре.',
  'press.key': 'Нажмите любую клавишу, чтобы задать сочетание...',
  'dashboard.keyboardShortcuts': 'Сочетания клавиш',
  'tooltip.changeShortcuts': 'Изменить сочетания клавиш',
  'global.changeShortcuts': 'Изменить сочетания клавиш',
  'retake_picture': 'Переснять фото',
  'picture': 'Фото',
  'error.faceCheck': 'Произошла ошибка при проверке совпадения лица. Попробуйте еще раз.',
  'faceCheck.see_score': 'Проверка лица',
  'recommendOrNot': 'Рекомендовать или нет',
  'recommended': 'Рекомендуется',
  'not_recommended': 'Не рекомендуется',
  'error.downgrade': 'Произошла ошибка при понижении запроса. Попробуйте еще раз.',
  'done.downgrade': 'Запрос успешно понижен.',
  'request.viewOutOfState.button': 'Принудительно "{consumeMode}"',
  'request.downgrade': 'Понизить',
  'request.extendStay': 'Продлить пребывание',
  'ResidencePermitNumber': 'Номер разрешения на проживание',
  'error.payment.noInternalReference': 'Для этого заявления требуется HQ ссылка. Пожалуйста, подождите, пока ссылка будет предоставлена.',
  'request.revision': 'Хотите активировать АвтоПропуск? Эта функция автоматически пропускает шаги, которые не требуют вашего ввода.',
  'notice.BORDER_PASS': 'Пограничный пропуск',
  'form.borderPassNumber': 'Номер пограничного пропуска',
  'transfert.viewOutOfState.desc': 'Вы просматриваете статус заявки. Пожалуйста, обратите внимание, что вы <b>предупреждены</b>: эта заявка может находиться в неправильном состоянии. Пожалуйста, внимательно проверьте документы, предоставленные клиентом, чтобы подтвердить точное состояние этой заявки. Поскольку вы находитесь в <b>режиме {consumeMode}</b>, у вас есть возможность <b>принудительно обработать как {transfertMode}</b>, даже если текущее состояние обычно этого не позволяет, если вы считаете это необходимым.',
  'form.dateOfBirth': 'Дата рождения',
  'form.issueDate': 'Дата выдачи',
  'form.authorizedCrossingPoints': 'Авторизованные пункты пересечения',
  'form.issuedBy': 'Выдано',
  'form.externalCode': 'Внешний код (ИКАО)',
  'err.invoke': 'Ошибка',
  'ask.pendingRequest': 'У вас есть ожидающая коррекция. Открыть её сейчас?',
  'entry.confirmation': 'Вы уверены, что вся предоставленная информация верна? Нажимая "Подтвердить", вы отправляете заявку.',
  'free': 'Бесплатно',
  'last_update': 'Последнее обновление',
  'count': 'Количество',
  'tooltip.linkedExtensions': 'Это продление пребывания. Нажмите, чтобы просмотреть детали.',
  'extension': 'Продление',
  'client.extended.badPaymentMetadata': 'Метаданные оплаты неверны. Попробуйте снова или обратитесь в службу поддержки, если проблема повторяется.',
  'DaysRequested': 'Запрошенные дни',
  'extensions.desc': 'Продление пребывания на рассмотрении',
  'extend': 'Продлить',
  'err.SpouseBirthDay.maxDate': 'Дата рождения супруга должна быть раньше сегодняшнего дня',
  'CheckboxVisaExtendFees': 'Подтверждаю, что предоставленная информация верна, и соглашаюсь с оплатой за продление пребывания, условиями и политикой конфиденциальности.',
  'AttestantDocument': 'Документ поручителя',
  'AffidavitCustody': 'Аффидевит об опеке',
  'CopyOfEntry': 'Копия въезда',
  'DepartureTicket': 'Билет на выезд',
  'DYN.Self': 'Сам',
  'DYN.Spouse/Dependent': 'Супруг/Зависимый',
  'DYN.Employee/Employer': 'Сотрудник/Работодатель',
  'DYN.Co-Director': 'Содиректор',
  'DYN.Lawyer': 'Адвокат',
  'VisaReference': 'Ссылка на визу',
  'ReasonForExtension': 'Причина продления',
  'AttestantID': 'ID поручителя',
  'AttestantName': 'Имя поручителя',
  'AttestantPhone': 'Телефон поручителя',
  'AttestantEmail': 'Электронная почта поручителя',
  'AttestantAddress': 'Адрес поручителя',
  'AttestantRelation': 'Связь с поручителем',
  'start_extend': 'Продлить пребывание',
  'visaExtend.title': 'Продление пребывания',
  'days': 'дней',
  'day': 'день',
  'kiosk.standby.text1': 'Начните заполнять вашу декларацию всего за несколько кликов на этом планшете или онлайн.',
  'kiosk.standbyDesc.text1': 'Перед началом ознакомьтесь с важной информацией:',
  'kiosk.standbyDesc.li1': 'Вы заполняете электронную форму, которая собирает ваши личные данные и информацию о поездке.',
  'kiosk.standbyDesc.li2': 'Вся предоставленная информация должна быть точной и соответствовать вашим проездным документам (паспорт, виза и т.д.).',
  'kiosk.standbyDesc.li3': 'После заполнения формы вы можете сразу перейти на иммиграционный контроль с вашими документами.',
  'kiosk.standbyDesc.li5': 'Если у вас возникнут трудности, обратитесь за помощью к сотрудникам на пограничном посту.',
  'kiosk.standbyDesc.text2': 'Нажмите "Начать", когда будете готовы заполнить декларацию о въезде.',
  'kiosk.success.title': 'Заявка успешно подана',
  'kiosk.success.text1': 'Теперь вы можете перейти к иммиграционному контролю с вашими проездными документами. Офицер проведет проверку и подтвердит ваш въезд в страну.',
  'kiosk.success.text2': 'Если у вас возникнут вопросы или трудности, не стесняйтесь обращаться за помощью к персоналу.',
  'confirm.revision': 'Подтвердить исправление',
  'print.isDone': 'Уведомление успешно распечатано? Пожалуйста, не забудьте передать напечатанное уведомление заявителю.',
  'form.hostPhone': 'Телефон хоста',
  'transit': 'Транзит',
  'conditionalEntry': 'Условный въезд',
  'departure': 'Отъезд',
  'form.paragraph': 'Пункт',
  'form.dateOfRefusal': 'Дата отказа',
  'form.purpose': 'Цель',
  'form.host': 'Хост',
  'form.officer': 'Офицер',
  'form.reportAt': 'Отчет по месту',
  'form.reportOn': 'Отчет по времени',
  'form.reportInterval': 'Интервал отчета',
  'notice.desc.RESTRICTION': 'Предварительное уведомление об ограничении информирует заявителя о документах, необходимых для завершения процесса. Вы можете выбрать недостающие документы, которые заявитель должен предоставить в указанный срок.',
  'notice.REFUSAL': 'Уведомление об отказе во въезде',
  'notice.desc.REFUSAL': 'Заявителю отказано во въезде в страну.',
  'notice.desc.REPORTING': 'Уведомление для посетителя позволяет заявителю въехать в страну, но может потребовать дальнейшей отчетности. Вы можете выбрать недостающие документы, которые заявитель должен предоставить в указанный срок.',
  'form.stationReference': 'Ссылка на станцию',
  'form.fullNames': 'Полное имя',
  'form.reportLocation': 'Место отчета',
  'form.daysUntilReport': 'Дни до отчета',
  'form.otherMissingDocument': 'Другой отсутствующий документ',
  'form.residentialAddress': 'Домашний адрес',
  'form.businessAddress': 'Бизнес-адрес',
  'form.hqReference': 'Ссылка HQ',
  'residentPermit': 'Разрешение на проживание',
  'notice.title': 'Доступные уведомления для печати',
  'notice.desc': 'Пожалуйста, выберите уведомление из списка ниже. После заполнения необходимых полей вы можете распечатать уведомление для заявителя.',
  'notice.RESTRICTION': 'Предварительное уведомление об ограничении',
  'notice.REPORTING': 'Уведомление для посетителя',
  'notice.RESTRICTION.desc': 'Заявитель должен предоставить недостающие документы в указанный срок.',
  'notice.REFUSAL.desc': 'Заявителю отказано во въезде в страну.',
  'notice.REPORTING.desc': 'Заявителю разрешен въезд, но может потребоваться дальнейшая отчетность.',
  'passportType.kioskWarning': 'Выбранная национальность относится к режиму Категории С. Немедленно обратитесь к иммиграционному офицеру.',
  'free.charge.total': 'Итого: бесплатно',
  'err.entryPoints': 'Произошла ошибка при загрузке планируемых пунктов въезда',
  'summary.your_meta': 'Ваши данные (нажмите, чтобы открыть)',
  'summary.payOnline': 'Предпочитаю оплатить онлайн сейчас, а не на стойке офицера по прибытии.',
  'summary.payOnline.desc': 'Согласие с опцией ниже переведет вас на страницу оплаты. Если вы решите не платить онлайн, вы сможете оплатить визовый сбор на стойке офицера по прибытии за тип визы "Виза по прибытии".',
  'summary.meta': 'Данные (нажмите, чтобы открыть)',
  'EmergencyLastName': 'Фамилия контакта на случай экстренной связи',
  'EmergencyFirstName': 'Имя контакта на случай экстренной связи',
  'EmergencyEmail': 'Электронная почта контакта на случай экстренной связи',
  'EmergencyPhone': 'Телефон для экстренной связи',
  'person.name': 'Имя выбранного человека',
  'DYN.identity-card': 'Удостоверение личности',
  'DYN.resident-permit': 'Временное разрешение на проживание',
  'DYN.identity-card.desc': 'Удостоверение личности – это документ, выдаваемый государством для внутренних целей идентификации.',
  'DYN.resident-permit.desc': 'Временное разрешение на проживание – это официальный документ, выданный правительством, позволяющий иностранному гражданину проживать в стране в течение определенного периода.',
  'NonOrdinaryPassMission': 'Причина официального визита',
  'PreviousConvictionsHomeAsk': 'Были ли вы или кто-либо из ваших спутников осуждены за какое-либо преступление в вашей стране проживания?',
  'PlaceOfBirthCountry': 'Страна рождения',
  'PlaceOfBirthCity': 'Город рождения',
  'OtherName': 'Другие имена',
  'travelName': 'Ссылка на заявление',
  'plannedEntry': 'Планируемый пункт въезда',
  'summary.title': 'Сводка',
  'urgent': 'Срочное',
  'visaType': 'Тип визы',
  'passportType': 'Тип документа',
  'passportType.acknowledge': 'Выбирая этот тип паспорта, вы признаете, что несоблюдение условий использования может привести к отказу во въезде.',
  'passportType.selectRefugeeNationality': 'Выберите гражданство для паспорта беженца <br>',
  'form.travelName.already': '<b>Эта заявление уже подано с указанной ниже ссылкой на него. Если вы хотите изменить заявление, начните новое.</b>',
  'application.current_person': 'Вы редактируете заявление для',
  'DYN.USD': '$ USD',
  'DYN.EUR': '€ EUR',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': '£ GBP',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'Редактировать заявителей',
  'request.existSaved': 'Найдено сохраненное заявление, хотите загрузить его данные? (Если нажмете "нет", заявление будет удалено и создано новое)',
  'participant.hasData': 'Вы уже ввели данные для этого заявителя. Если продолжите, данные будут утеряны. Вы уверены, что хотите продолжить?',
  'participant.selectAtLeastOne': 'Пожалуйста, выберите как минимум одного участника, чтобы продолжить.',
  'participants.title': 'Заявители',
  'participants.desc': 'Выберите себя и/или других заявителей, которые будут частью этого заявления. </br><b>Оплата в конце будет произведена за всех выбранных заявителей.</b></br></br>Вы можете добавить/удалить заявителя или редактировать его заявку в любое время, нажав на имя, которое появится над формой.</br></br>{participantText}',
  'participant.ready': 'Когда будете готовы, нажмите "Продолжить".',
  'participant.missing': 'Перед продолжением создайте хотя бы одного заявителя.',
  'travelName.title': 'Ссылка на заявление',
  'form.travelName': 'Ссылка на заявление',
  'form.travelName.desc': 'Ссылка на заявление будет использоваться для облегчения идентификации вашего заявления.',
  'nationality.title': 'Национальность',
  'nationality.desc': 'Пожалуйста, выберите вашу страну в соответствии с используемым паспортом.',
  'passportType.title': 'Тип документа',
  'passportType.desc': 'Пожалуйста, выберите тип проездного документа, который вы используете для этого заявления.',
  'visaType.title': 'Тип визы',
  'visaType.desc': 'Пожалуйста, выберите тип визы, на который вы хотите подать заявление. Этот список варьируется в зависимости от вашего гражданства и типа паспорта.',
  'urgent.title': 'Обычная/Срочная Виза',
  'urgent.desc': 'Если ваше заявление на визу <b>срочное</b>, выберите этот вариант. Время обработки будет короче, но за эту услугу взимается <b>дополнительная плата</b>.</br></br>',
  'priority.normal': 'Обычный',
  'priority.urgent': 'Срочный',
  'priority.normal.DYN.desc': 'Обрабатывается в течение семи (7) рабочих дней.',
  'priority.urgent.DYN.desc': 'Обрабатывается в течение трех (3) рабочих дней.',
  'visa.paidOnArrival.title': 'Виза, оплачиваемая по прибытии',
  'visa.paidOnArrival.desc': 'Позволяет имеющим право путешественникам получить визу по прибытии в пункт въезда назначения, упрощая процесс въезда для краткосрочных поездок.',
  'visa.paidOnline.title': 'Виза, оплачиваемая онлайн',
  'visa.paidOnline.desc': 'Позволяет однократный или многократный въезд в страну в течение одного (1) месяца, требуя новой визы для последующих въездов.',
  'PassportType': 'Тип паспорта',
  'PassportCountry': 'Страна выдачи паспорта',
  'form.passportCountry': 'Страна выдачи паспорта',
  'DYN.ordinary': 'Обычный паспорт',
  'DYN.diplomatic': 'Дипломатический паспорт',
  'DYN.official': 'Официальный паспорт',
  'DYN.service': 'Служебный паспорт',
  'DYN.refugee': 'Паспорт беженца или проездной документ',
  'open.register': 'Открыть реестр',
  'supervision.nofee': 'Требуется подтверждение супервизора для запроса без штрафных санкций.',
  'NoFeeProof': 'Документ об освобождении от оплаты',
  'webcam.nofeeProof.confirm': 'Пожалуйста, сфотографируйте документ об освобождении от оплаты (No Fee Proof).',
  'DYN.ordinary.desc': 'Обычный паспорт — это самый распространенный тип паспорта, выдаваемый гражданам для общих целей путешествий.',
  'DYN.diplomatic.desc': 'Дипломатический паспорт выдается дипломатам и консулам для официальных поездок и проживания за границей.',
  'DYN.refugee.desc': 'Паспорт беженца выдается страной людям, которых она признает беженцами, для путешествий за границу.',
  'DYN.official.desc': 'Официальный паспорт выдается государственным служащим для официальных поездок и проживания за границей.',
  'DYN.service.desc': 'Служебный паспорт выдается государственным служащим для официальных поездок и проживания за границей.',
  'DYN.marine': 'Пасспорт моряка',
  'DYN.marine.desc': 'Паспорт моряка выдается морякам и членам экипажа для поездок и проживания за границей.',
  'DYN.laissez-passer': 'Паспорт ООН',
  'DYN.laissez-passer.desc': 'Паспорт ООН —  это документ, выдаваемый Организацией Объединенных Наций или её агентствами для официальных поездок и проживания за границей.',
  'Urgent': 'Это срочный запрос. Я понимаю, что время обработки будет короче, но стоимость будет выше.',
  'photo.passport.scanned': 'Паспорт отсканирован',
  'review.nr.final': 'Окончательный обзор',
  'review.nr': 'Обзор №',
  'err.ArrivalDate.maxDateMilliTo': 'Необходимо, чтобы между датой истечения срока действия вашего паспорта и датой вашего прибытия в страну прошло не менее шести (6) месяцев. Пожалуйста, обновите этот паспорт перед подачей заявления на визу.',
  'err.DateOfExpiry.maxDateMilliTo': 'Ваш паспорт истекает менее чем через шесть (6) месяцев с даты прибытия в страну. Пожалуйста, обновите этот паспорт перед подачей заявления на визу.',
  'place.update.error': 'Произошла ошибка при обновлении места',
  'dashboard.kiosk.start': 'Начать процесс',
  'form.role.kiosk': 'Киоск',
  'FundsAvailable': 'Сумма',
  'FundsAvailableCurrency': 'Валюта',
  'emergency_contact_text': 'Укажите контактные данные человека, с которым можно связаться, в случае чрезвычайной ситуации.',
  'emergency_contact': 'Контакт для экстренной связи / Ближайший родственник',
  'err.BirthDay.mustBeEqualOrBefore': 'Дата рождения должна быть раньше или равна дате выдачи паспорта',
  'err.DateOfIssue.mustBeEqualOrAfter': 'Дата выдачи должна быть позже или равна дате рождения',
  'internet.lost': 'Интернет-соединение потеряно.</br>Пожалуйста, проверьте ваше соединение.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'Ваш паспорт истекает менее чем через шесть (6) месяцев с сегодняшнего дня. Пожалуйста, обновите этот паспорт перед подачей заявления на визу.',
  'err.DepartureDate.maxDateMilliFrom': 'Дата выезда слишком отдалена от даты прибытия. Пожалуйста, обратитесь к срокам действия визы.',
  'requirements': 'Требования',
  'err.file.size': 'Размер файла слишком большой. Максимальный размер: ',
  'revision.success': 'Ваш запрос успешно обновлен. Вы получите письмо с QR-кодом, как только он будет одобрен.',
  'revision.free': 'Бесплатное исправление',
  'revision.start': 'Мы заполнили поля на основе предоставленной вами информации за исключением тех полей, которые вызвали проблемы. Пожалуйста, проверьте информацию и исправьте её. Хотите продолжить?',
  'file_uploaded': 'Файл уже загружен и сохранен',
  'refusal.desc2': 'Следующие поля вызывают проблему:',
  'start_correction': 'Начать исправление',
  'payment.selectMode': 'Выберите поля, которые вызывают проблему. Вы можете выбрать несколько полей.',
  'suspendReason.desc': 'Напишите краткое описание запроса на исправление. Это описание будет отправлено заявителю вместе с выбранными проблемной полями.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'Дата прибытия должна быть раньше или равна дате выезда',
  'err.DepartureDate.mustBeEqualOrAfter': 'Дата выезда должна быть позже или равна дате прибытия',
  'qr.request_desc': 'Этот QR-код является цифровым пропуском для обработки визы. Правительство оставляет за собой право одобрить или отказать во въезде в момент контроля визы.',
  'request_state.PENDING': 'Ожидание',
  'document.Screening': 'Проверка',
  'err.SpouseBirthDay.max': 'Недопустимая дата рождения супруга',
  'err.ArrivalDate.min': 'Недопустимая дата прибытия',
  'err.DepartureDate.min': 'Недопустимая дата выезда',
  'err.DateOfIssue.max': 'Недопустимая дата выдачи',
  'err.BirthDay.max': 'Недопустимая дата рождения',
  'err.dependants_date_of_birth.max': 'Недопустимая дата рождения зависимого',
  'err.DateOfExpiry.min': 'Недопустимая дата окончания',
  'dependants': 'Зависимые лица',
  'male': 'Мужской',
  'female': 'Женский',
  'other': 'Другой',
  'single': 'Не женат/Не замужем',
  'married': 'Женат/Замужем',
  'separated': 'В разводе',
  'divorced': 'Разведен/а',
  'widowed': 'Вдова/Вдовец',
  'select_reason_first': 'Пожалуйста, выберите причину визита на предыдущей странице, чтобы увидеть список требуемых документов.',
  'visaIntro.title': 'Заявка',
  'remove': 'Удалить',
  'dependant_add': 'Добавить зависимого',
  'dependant': 'Зависимый',
  'upload_file': 'Загрузить файл (< {size})',
  'PassportPhoto': 'Недавнее фото лица',
  'PassportScan': 'Страница биографических данных паспорта',
  'EventInvitationLetter': 'Письмо-приглашение на мероприятие',
  'ProofOfResidenceHost': 'Подтверждение места жительства/бронирования хозяина (с подписью)',
  'AddressAtDestination': 'Адрес по месту назначения',
  'HostInvitationLetter': 'Письмо-приглашение от хоста',
  'ProofOfResidence': 'Подтверждение проживания',
  'ApplicationLetter': 'Заявление',
  'ResidentialStatusOfHost': 'Статус проживания хоста',
  'ReasonOfVisitProof': 'Подтверждение цели визита',
  'BusinessLetter': 'Деловое письмо/Индивидуальное письмо',
  'BusinessProfile': 'Бизнес-профиль',
  'InvitationLetterAndBusinessProfile': 'Требуется пригласительное письмо и документы принимающей компании (с подписью)',
  'InvitationLetter': 'Письмо приглашения',
  'LetterOfAcceptanceFromSchool': 'Письмо о приеме',
  'DYN.male': 'Мужской',
  'DYN.female': 'Женский',
  'DYN.other': 'Другой',
  'DYN.single': 'Не женат/Не замужем',
  'DYN.married': 'Женат/Замужем',
  'DYN.separated': 'В разводе',
  'DYN.divorced': 'Разведен/а',
  'DYN.widowed': 'Вдова/Вдовец',
  'DYN.married_according_to_custom': 'Женат/Замужем по обычаям',
  'DYN.religiously_married': 'Женат/Замужем по религиозным обычаям',
  'passport.valid': 'Сканированный документ не выглядит измененным или аннулированным и подписан страной, выдавшей его.',
  'travel_information_title': 'Предупреждение',
  'visaPrice.desc': 'Вам потребуется произвести оплату Visa или MasterCard в конце заявки. Эта оплата не подлежит возврату.',
  'visaPrice': 'Стоимость визы',
  'required': 'Обязательно',
  'DYN.holiday_visa': 'Отдых',
  'DYN.live_here': 'Долгосрочное проживание',
  'DYN.business_visa': 'Бизнес',
  'DYN.conferencing_visa': 'Конференция',
  'DYN.transit_visa': 'Транзит',
  'DYN.student_visa': 'Учеба',
  'DYN.sports_visa': 'Спорт',
  'DYN.arts_visa': 'Искусство',
  'DYN.other_visa': 'Другое',
  'DYN.event_visa': 'Событие',
  'form.importantRead': 'ВАЖНО - ВНИМАТЕЛЬНО ПРОЧИТАЙТЕ',
  'form.completeInEnglish': 'Заполняйте чётко на английском языке.',
  'form.selectApplicableFields': 'Выберите все соответствующие поля ниже.',
  'document': 'Документ',
  'documents_attached': 'Документы для прикрепления',
  'Dependants': 'Зависимые лица',
  'dependants_name': 'Имя',
  'dependants_passport_number': 'Номер паспорта',
  'dependants_date_of_birth': 'Дата рождения',
  'dependants_place_of_birth': 'Место рождения',
  'Spouse': 'Супруг',
  'SpouseFullName': 'Имя супруга',
  'SpousePassportNumber': 'Номер паспорта супруга',
  'SpouseBirthDay': 'Дата рождения супруга',
  'SpousePlaceOfBirth': 'Место рождения супруга',
  'ArrivalDate': 'Ожидаемая дата прибытия',
  'DepartureDate': 'Ожидаемая дата выезда',
  'ReferencePreviousVisa': 'Ссылка на предыдущую визу',
  'PreviousConvictionsHome': 'Суть судимости в стране проживания',
  'travel_information': 'Информация о поездке',
  'DateOfIssue': 'Дата выдачи',
  'DateOfExpiry': 'Дата окончания',
  'PlaceofIssue': 'Место выдачи',
  'Email': 'Электронная почта',
  'Phone': 'Номер телефона',
  'form.selectCountry': 'Выберите страну',
  'HomeAddress': 'Текущий адрес проживания',
  'HostName': 'Имя принимающей стороны',
  'err.InvitingCompanyName.required': 'Название приглашающей компании обязательно',
  'InvitingCompanyName': 'Название приглашающей компании',
  'form.seniority': 'Уровень старшинства',
  'LastName': 'Фамилия',
  'FirstName': 'Имя (имена)',
  'BirthDay': 'Дата рождения (Точно как в паспорте)',
  'PlaceOfBirth': 'Место рождения',
  'Gender': 'Пол',
  'MaritalStatus': 'Семейное положение',
  'CheckboxVisaFees': 'Я подтверждаю, что предоставленная информация верна и точна, и я соглашаюсь с визовыми сборами, условиями и политикой конфиденциальности.',
  'PassportNumber': 'Номер паспорта',
  'Nationality': 'Национальность',
  'err.nationality.required': 'Национальность обязательна.',
  'PurposeOfVisit': 'Цель визита',
  'VisaType': 'Тип визы',
  'visitor_details': 'Данные заявителя',
  'personal_details': 'Личные данные',
  'contact_details': 'Контактные данные',
  'miscellaneous_details': 'Информация о поездке',
  'spouse_details': 'Данные супруга',
  'payment': 'Оплата',
  'global.scan_qr': 'Проверить QR-код',
  'qr.nosuch': 'Загрузка… QR-код еще не найден в системе. Проверьте подключение к интернету.',
  'qr.faked': 'Ответ сервера: QR-код не существует. Вероятно, это подделка!',
  'qr.quicklook': 'Ключевая информация',
  'global.toPayments.DYN.': 'Просмотр заявок',
  'payment.duplicate.open': 'Открыть новый платеж?',
  'ONE_DAY': '1 день',
  'THREE_DAYS': '3 дня',
  'ONE_WEEK': '1 неделя',
  'TWO_WEEKS': '2 недели',
  'ONE_MONTH': '1 месяц',
  'TWO_MONTHS': '2 месяца',
  'SIX_MONTHS': '6 месяцев',
  'ONE_YEAR': '1 год',
  'place_created.desc': 'Новое место создано и доступно для использования.',
  'payment_status.DYN.NONE': '– Нет фильтра –',
  'dropdown.state': 'Статус',
  'payment.qrList.title': 'Список QR-платежей',
  'see.qr_list': 'Посмотреть список QR-кодов',
  'form.role.partner_registrer': 'Регистрация партнера',
  'form.reason': 'Причина',
  'global.reject': 'Отклонить',
  'payment.validate_desc': 'Вы уверены, что хотите подтвердить этот платеж?',
  'payment.reject_desc': 'Вы уверены, что хотите отклонить этот платеж? Не забудьте указать причину.',
  'qr.title': 'QR-код',
  'dashboard': 'Панель управления',
  'dashboard.people.DYN.': 'Сохраненные заявители',
  'dashboard.my_account': 'Мой аккаунт',
  'form.id': 'ID',
  'payments.scan': 'Сканировать QR',
  'print.qr.desc': 'Это уникальный и защищенный QR-код, который можно использовать столько раз, сколько указано. Не портите его, чтобы он оставался действительным.',
  'print.qr.title': 'QR-код',
  'print.informations': 'Информация',
  'print.notice.folding': 'Инструкции по сгибанию',
  'print.notice.desc2': 'В случае любых вопросов, связанных с этим документом, свяжитесь с поддержкой по телефону или электронной почте.',
  'print.notice.desc1': 'Держите этот документ подальше от воды и огня.',
  'print.notice.title': 'Уведомление',
  'client.extended.openSuchPayment': 'Платеж уже активен для этого пользователя',
  'form.externalId': 'Ссылка на платеж',
  'form.userExternalId': 'Внешний ID',
  'global.confirm': 'Подтвердить',
  'global.submit': 'Отправить',
  'global.back': 'Назад',
  'global.close': 'Закрыть',
  'global.contact_support': 'Связаться с поддержкой',
  'global.previous': 'Назад',
  'global.next': 'Далее',
  'global.accept': 'Принять',
  'global.support': 'Поддержка',
  'global.consume': 'Использовать',
  'global.validate': 'Подтвердить',
  'global.reset': 'Сброс',
  'global.delete': 'Удалить',
  'global.update': 'Обновить',
  'global.download': 'Скачать',
  'global.print': 'Печать',
  'global.print_c7': 'Распечатать билет',
  'global.checkIn': 'Зарегистрироваться',
  'choose-lang.title': 'Предпочтительный язык',
  'choose-lang.desc': 'Пожалуйста, выберите язык, который будет использоваться в этом приложении.',
  'global.personalNum': 'Персональный номер',
  'global.passportNum': 'Номер паспорта',
  'global.add': 'Добавить',
  'global.block': 'Заблокировать',
  'global.blocked': 'Заблокирован',
  'global.unblock': 'Разблокировать',
  'global.daily_otp': 'Ежедневный код',
  'global.refresh': 'Обновить',
  'global.connect': 'Войти',
  'global.disconnect': 'Отключиться',
  'form.email': 'Электронная почта',
  'form.name': 'Имя',
  'form.firstName': 'Имя (имена)',
  'form.lastName': 'Фамилия',
  'form.password': 'Пароль',
  'form.password2': 'Повторите пароль',
  'form.linkType': 'Как связан заявитель с вами?',
  'form.userId': 'ID пользователя',
  'form.parentId': 'ID родителя',
  'form.amount': 'Сумма',
  'form.currency': 'Валюта',
  'form.buyingOption': 'Купленный документ',
  'form.place': 'Место',
  'form.role': 'Роль',
  'form.connectUAPattern': 'Шаблон пользователя-агента',
  'form.connectIPRange': 'Диапазон IP-адресов',
  'form.state': 'Штат',
  'form.created_date': 'Дата создания',
  'form.created_place': 'Место создания',
  'form.consumed_place': 'Место потребления',
  'form.email_code': 'Код из электронной почты',
  'form.phone': 'Номер телефона',
  'form.worker': 'ID сотрудника',
  'form.password_old': 'Текущий пароль',
  'form.password_new': 'Новый пароль',
  'form.idCard': 'Номер ID карты',
  'form.type.CASH': 'Наличные',
  'form.type.CARD': 'Карта',
  'form.role.customer': 'Клиент',
  'form.role.worker': 'Работник',
  'yes': 'Да',
  'no': 'Нет',
  'form.borderPass': 'Выдать пропуск на границу',
  'form.role.orbis_consumer': 'Потребитель Orbis',
  'form.role.admin': 'Администратор',
  'form.perm2.DYN.': 'Использовать заявку на визу',
  'form.perm3.DYN.': 'Проверить заявку на визу',
  'form.perm4.DYN.': 'Создание/управление местами, пользователями и визовыми заявками',
  'client.extended.clientNotAllowed': 'Ваш аккаунт не имеет доступа к этому месту. Проверьте настройки подключения.',
  'err.submit': 'Ошибка при отправке формы',
  'err.place.required': 'Место обязательно',
  'err.noSmsPerm': 'Право на отправку SMS не предоставлено',
  'err.noSmsReceive': 'Не удается связаться с чтением SMS',
  'helps.showProceed': 'Показать ход процесса',
  'helps.showScan': 'Показать документ сканирования',
  'payment_status.DYN.undefined': 'Текущий статус - не операция',
  'client.extended.missingResourceLogin': 'Не удалось подключиться, неверные учетные данные',
  'client.extended.linkedAccountExists': 'Аккаунт с этим адресом электронной почты уже существует',
  'client.extended.attachedPayments': 'Вы не можете изменить этого человека, поскольку с ним уже связана созданная заявка.',
  'client.extended.badPayload': 'Неправильная информация в запросе',
  'client.extended.placeNotAllowed': 'Место не разрешено',
  'client.extended.locked': 'Аккаунт заблокирован',
  'client.extended.clientBadOtp': 'Неверный ежедневный код',
  'client.extended.confirmationRequired': 'Требуется подтверждение',
  'confirmationRequired.email': 'Ссылка для подтверждения отправлена на вашу электронную почту. Проверьте входящие сообщения и подтвердите перед входом.',
  'confirmationRequired.sms': 'Ссылка для подтверждения отправлена по SMS. Проверьте ваши сообщения и подтвердите перед входом.',
  'client.extended.badPaymentConfirmation': 'Платёж не может быть выполнен: одна из проверок не пройдена',
  'time': 'Время',
  'place': 'Место',
  'home.first': 'Ваш аккаунт подтвержден, вы можете войти в систему.',
  'payOnline': 'Оплатить онлайн',
  'login.sign_in': 'Войти',
  'photo.unavailable': 'Фото недоступно',
  'global.entry': 'Вход',
  'global.exit': 'Выход',
  'menu.users': 'Пользователи',
  'menu.places': 'Места',
  'create_user.title': 'Создать пользователя',
  'create_payment.title': 'Создать платеж',
  'create_place.title': 'Создать место',
  'users.title': 'База данных пользователей',
  'payments.title': 'База данных платежей',
  'payments.download_csv': 'Скачать CSV',
  'create_card_payment.title': 'Онлайн платеж',
  'places.title': 'Список мест',
  'forgot_password.title': 'Сброс пароля',
  'welcome.title_1.DYN.': 'Добро пожаловать в {appName}',
  'welcome.text_1.DYN.': 'Добро пожаловать на официальный портал {appName}.<br>Этот онлайн-сервис упрощает и обеспечивает безопасность получения ваших официальных документов.',
  'welcome.text_1.1.DYN.': 'Готовы узнать, как это работает? Давайте начнем!',
  'welcome.title_2.DYN.': 'Что такое {appName}?',
  'welcome.text_2.DYN.': '{appName} — это защищённая цифровая платформа, которая позволяет вам запрашивать официальные документы онлайн: удостоверение личности, паспорт, вид на жительство и многое другое.',
  'welcome.text_2.1.DYN.': 'Подавайте заявку из любой точки мира и получайте свои документы по электронной почте с уникальным QR-кодом, гарантирующим их подлинность.',
  'welcome.title_3.DYN.': 'Как работник',
  'welcome.text_3.DYN.': 'С помощью {appName} вы можете управлять заявками офлайн. Мы уверены в нашей безопасной и надёжной технологии генерации QR-кодов.',
  'welcome.text_3.1.DYN.': 'Вы также можете управлять пользователями и местами вашей организации.',
  'welcome.text_4.DYN.': 'Вы даже можете управлять заявками в офлайн-режиме. Мы уверены в нашей безопасной и надёжной технологии генерации QR-кодов.',
  'welcome.text_4.1.DYN.': 'Как только вы снова будете онлайн, всё автоматически синхронизируется.',
  'welcome.title_5.DYN.': 'Начните оформление заявки',
  'welcome.text_5.DYN.': 'На следующих страницах вы сможете подать заявку на официальные документы онлайн всего за несколько кликов.<br><br>После одобрения вашей заявки вы получите документы по электронной почте с надёжным QR-кодом, который содержит всю необходимую информацию для быстрой и надёжной проверки.',
  'payment_status.DYN.PROPOSED': 'Ожидается оплата',
  'payment_status.DYN.PAID': 'Готов к регистрации',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'Ожидается проверка',
  'payment_status.DYN.USED': 'Завершен',
  'payment_status.DYN.DUPLICATED': 'Дублирован',
  'payment_status.DYN.REFUNDED': 'Возвращено',
  'payment_status.DYN.EXPIRED': 'Отклонен',
  'payment_status.DYN.PENDING': 'Ожидается исправление',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'Оплата позже - не подтверждена',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'Бесплатно - не подтверждено',
  'payment_status.DYN.DELAY_PAY': 'Готов к оплате по прибытии',
  'payments.validate': 'Подтвердить',
  'documentContinue.title': 'Продолжить покупки',
  'bt.available_devices': 'Доступные Bluetooth-устройства',
  'bt.no_available_devices': 'Доступные Bluetooth-устройства не обнаружены',
  'emailSend.title': 'Подтверждение по электронной почте',
  'emailSend.description': 'Для того, чтобы подтвердить ваш аккаунт, вы должны нажать на ссылку, содержащуюся в письме, отправленном на вашу электронную почту в течение 24 часов.',
  'emailValid.title': 'Аккаунт подтвержден',
  'emailValid.description': 'Ваш аккаунт в {appName} успешно подтвержден. Теперь вы можете войти в свой личный кабинет, используя свои учетные данные.',
  'documentManagement.title': 'Заявление на визу',
  'preenroll.title': 'Предварительная регистрация',
  'passportEmbassy.title': 'Документ посольства',
  'zwevisa.title': 'Виза',
  'passwordSend.title': 'Подтверждение отправлено',
  'passwordSend.description': 'Вы получили письмо с подтверждением, содержащее ссылку для сброса пароля. У вас есть 24 часа, чтобы нажать на неё.',
  'forgotPassword.title': 'Забыли пароль',
  'forgotPassword.description': 'Чтобы сбросить пароль, введите ниже свою электронную почту.',
  'forgotPassword.description.electron': 'Чтобы сбросить пароль, введите ниже свою электронную почту. Если вы пытаетесь восстановить пароль для учетной записи <b>активного каталога</b>, пожалуйста, свяжитесь с поддержкой.',
  'passwordNew.title': 'Новый пароль',
  'modifiedPassword.title': 'Пароль изменен',
  'modifiedPassword.description': 'Пароль был изменен. Пожалуйста, войдите снова.',
  'people.title.DYN.': 'Сохраненные заявители',
  'people.addPerson.DYN.': 'Создать нового заявителя',
  'meansPayment.title': 'Способы оплаты',
  'onlinePayment.title': 'Оплата через PayPal',
  'onlinePayment.pay': 'Оплатить',
  'qrPayment.title': 'Оплата с помощью QR-кода',
  'form.expireDate': 'Срок действия',
  'successPayment.title': 'Регистрация заявления',
  'trackingControl.title.DYN.': 'Отслеживание этого заявления',
  'modifyData': 'Изменить данные',
  'stopModifyData': 'Прекратить изменение данных',
  'askVisa': 'Запросить визу',
  'peopleNew.title.DYN.': 'Новый заявитель',
  'peopleFound.title.DYN.': 'Найден человек',
  'peopleFound.description.DYN.': 'Человек, соответствующий введенной вами информации, был добавлен в список сохраненных людей.',
  'payment.commandHistory': 'История платежей',
  'menu.placesPerm': 'Места и разрешения',
  'block.message': 'Вы хотите заблокировать этого пользователя?',
  'menu.addPlace': 'Добавить место',
  'label.numberAccount': 'Номер счета',
  'place.sheet.open': 'Открыть карточку места',
  'place.delete': 'Удалить связь с этим местом',
  'place.update.success': 'Место успешно обновлено.',
  'place.new': 'Новое место',
  'place.create': 'Создать место',
  'place.add.ask': 'Вы хотите привязать это место к этому пользователю?',
  'place.delete.link': 'Удалить связь с этим местом',
  'place.delete.link.ask': 'Вы уверены, что хотите отменить привязку этого места?',
  'place.delete.link.done': 'Вы успешно удалили привязку к месту.',
  'user.new': 'Новый пользователь',
  'user.create': 'Создать пользователя',
  'user.created': 'Создание нового пользователя прошло успешно. Теперь можно использовать этот аккаунт.',
  'user.sheet.open': 'Открыть карточку пользователя',
  'payment.sheet.open': 'Открыть карточку платежа',
  'err.createplace': 'Не удалось создать. Идентификатор уже существует.',
  'place.parent': 'Родительское место',
  'dropdown.qr': 'Сканировать QR-код',
  'dropdown.pass': 'Сканировать документ',
  'err.noReader': 'Читатель не подключен. Пожалуйста, подключите читателя для продолжения.',
  'err.noCard': 'В устройстве не обнаружен действующий биометрический документ. Это может быть связано с использованием небиометрического документа, предъявлением неразрешенной копии или подделки, либо неисправностью антенны для чтения.',
  'err.noConnect': 'Этот документ не соответствует стандартным протоколам ICAO. Это может быть связано с использованием небиометрического документа, предъявлением неразрешенной копии или подделки, либо неисправностью антенны для чтения.',
  'err.noBAC': 'Не удалось установить защищенный канал с документом. Он подлинный? Тщательно проверьте документ вручную и опросите владельца.',
  'err.alteredDoc': 'Поля документа не читаются. Он подлинный? Тщательно проверьте документ вручную и опросите владельца.',
  'err.revokedDocSigner': 'Подписант этого документа был аннулирован его выдающей организацией. Возможно, этот документ был подписан мошенническим способом. Тщательно опросите владельца об этом.',
  'err.unverifiedDoc': 'Подлинность документа не удалось проверить, ошибка в протоколе аутентификации. Это может быть признаком того, что документ был выдан за пределами страны, не по стандартам ICAO, является подделкой или неисправностью антенны для чтения.',
  'err.noPassiveAuthentication': 'Подлинность документа не удалось проверить, ошибка в протоколе аутентификации. Это может быть подделка или неисправность антенны для чтения.',
  'err.noResult': 'Файл не найден',
  'payment.new.DYN.': 'Новый выезд без визы',
  'payment.created.register': 'Зарегистрированный платеж',
  'payment.created': 'Ваш платеж сохранен и теперь отображается в списке платежей.',
  'payment.created.qr': 'На указанный адрес электронной почты отправлено письмо с сгенерированным QR-кодом.',
  'idcard.number': 'Номер удостоверения личности',
  'form.userCreator': 'Создано пользователем',
  'form.userRefund': 'Возвращено пользователем',
  'form.userConsumed': 'Использовано пользователем',
  'PRICEUP': 'Цена 0-9',
  'PRICEDOWN': 'Цена 9-0',
  'RECENT': 'Самые новые',
  'LATEST': 'Более старые',
  'STATUSUP': 'Статус a-z',
  'STATUSDOWN': 'Статус z-a',
  'payment.success': 'Ваш платеж зарегистрирован',
  'payment.consume.ask.DYN.': 'Вы действительно хотите зарегистрировать/выписать этот визовый запрос?',
  'checkinOut.refuse': 'Вы действительно хотите отклонить этот запрос?',
  'payment.duplicate': 'Дублировать',
  'payment.duplicate.ask': 'Вы действительно хотите дублировать этот платеж?',
  'payment.duplicate.done': 'Ваш платеж успешно дублирован',
  'tooltip.duplicatePayment': 'Дублировать этот платеж для повторного использования',
  'payment.refund.ask': 'Вы действительно хотите вернуть этот платеж?',
  'payment.refund.done': 'Ваш платеж успешно возвращен',
  'payment.refund.exist': 'Этот платеж уже был возвращен',
  'payment.paid.error': 'Ваш платеж должен быть в статусе «Завершено»',
  'block.done': 'Аккаунт заблокирован',
  'block.unblock': 'Аккаунт разблокирован',
  'place-add.add': 'Добавление места',
  'permission.title': 'Требуется разрешение: Камера',
  'qr.see': 'Посмотреть QR-код',
  'qr.desc.DYN.': 'Вот QR-код для заявления. Он появится при печати и будет отправлен на электронный адрес, указанный при регистрации.',
  'dashboard.place.verif': 'Если вы не ввели местоположение, сделайте это',
  'block.yourself': 'Вы не можете заблокировать себя',
  'lastPlace.delete': 'Последнее место в этой учетной записи будет удалено. Это сделает эту учетную запись непригодной для использования. Продолжить?',
  'place.add.done': 'Это место успешно добавлено этому пользователю',
  'no.connection': 'Для доступа к этой странице необходимо подключение к интернету. Пожалуйста, войдите снова',
  'place.delete.success': 'Это место было удалено.',
  'wrong.current': 'Вы ввели неверный текущий пароль',
  'no.place': 'Нет места для этой учетной записи.',
  'email.error': 'Похожая электронная почта уже существует',
  'email.notexist': 'Электронная почта не существует',
  'one.payment': 'Должен быть создан хотя бы один платеж и/или применен фильтр.',
  'err.client.extended.uuidUsed': 'Этот платеж уже был использован',
  'client.extended.uuidUsed': 'Этот платеж уже был использован',
  'no.activecamera': 'Активная камера не найдена',
  'no.accessPermission': 'Эта учетная запись не имеет доступа',
  'print.name': 'Принтер',
  'print.success': 'Ваш билет напечатан',
  'print.need': 'Сначала необходимо подключиться к принтеру, чтобы иметь возможность печатать',
  'printer.connect': 'Вы подключены к принтеру:',
  'permission.desc': 'Для использования сервиса необходимо разрешение на использование камеры вашего устройства',
  'createPeople.ask.DYN.': 'Вы действительно хотите создать нового заявителя?',
  'createPeopleDuplicate.ask.DYN.': 'Похоже, что человек с таким же именем уже существует в списке зарегистрированных людей. Вы все еще хотите создать этого человека?',
  'deletePerson.DYN.': 'Удалить этого заявителя',
  'deletePerson.ask.DYN.': 'Вы уверены, что хотите удалить этого человека?',
  'deletePerson.valid.DYN.': 'Человек удален',
  'personModification.ask.DYN.': 'Вы уверены, что хотите изменить данные этого человека?',
  'personModification.valid.DYN.': 'Данные человека изменены',
  'noPayment': 'Ни одного платежа',
  'selfie.desc': 'Для запроса документа требуется фотография. Пожалуйста, убедитесь, что вы находитесь в хорошем освещении и держите телефон устойчиво, чтобы избежать размытого изображения. Также убедитесь, что все черты вашего лица четко видны на фотографии.',
  'ZWEVISA.title': 'Виза',
  'EMBASSYPASS.title': 'Посольский паспорт',
  'PREENROLL.title': 'Предварительная регистрация',
  'DYN.NOK': 'Запрос отклонен',
  'WIP': 'Работа в процессе',
  'menu.requests.DYN.': 'Заявления',
  'menu.createRequests.DYN.': 'Новое заявление',
  'request_state.SUBMITTED': 'Отправлено',
  'request_state.CONFIRMED': 'Подтверждено',
  'request_state.TREATED': 'Обработано',
  'request_state.TRANSFERRED': 'Передано',
  'request_state.CANCELLED': 'Отменено',
  'request_state.REFUSED': 'Отклонено',
  'request_state.UNUSABLE': 'Недействительно',
  'request_state.NULL': 'Неоплачено',
  'request_state.NONE': '-- Без фильтра --',
  'ask.disconnect': 'Вы уверены, что хотите выйти?',
  'global.yes': 'Да',
  'applicant.gender.male': 'Мужской',
  'applicant.gender.female': 'Женский',
  'applicant.gender.other': 'Другой',
  'marital.status.single': 'Холост/Не замужем',
  'marital.status.married': 'Женат/Замужем',
  'marital.status.separated': 'Разделен',
  'marital.status.divorced': 'Разведен(а)',
  'marital.status.widowed': 'Вдовец/Вдова',
  'marital.status.religiously_married': 'Женат(а) религиозно',
  'marital.status.married_according_to_custom': 'Женат(а) по обычаю',
  'marital.status.other': 'Другой',
  'marital.status.unknown': 'Неизвестно',
  'request_state.PROPOSED': 'Ожидает оплаты',
  'request_state.PAID': 'Завершено',
  'request_state.USED': 'Закрыто',
  'request_state.DUPLICATED': 'Дублировано',
  'request_state.REFUNDED': 'Возвращено',
  'request_state.EXPIRED': 'Отклонено',
  'request_state.PAID_NOT_CONFIRMED': 'Ожидает проверки',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'Оплата позже - не подтверждено',
  'request_state.DELAY_PAY': 'Готово к оплате по прибытии',
  'payment_status.DYN.0': 'Ожидает оплаты',
  'payment_status.DYN.1': 'Готов к регистрации',
  'payment_status.DYN.6': 'Ожидает проверки',
  'payment_status.DYN.2.9': 'Ожидает контроля',
  'payment_status.DYN.2.10': 'Контроль завершен',
  'payment_status.desc.DYN.2.10': 'Заявление было рассмотрено супервайзером и готово к обработке офицером пограничного контроля.',
  'payment_status.desc.DYN.2.9': 'Заявление ожидает контроля. Возможно, супервайзер должен рассмотреть заявление, прежде чем его можно будет обработать офицером пограничного контроля.',
  'payment_status.DYN.7': 'Ожидает исправления',
  'payment_status.DYN.8': 'Оплата позже - не подтверждено',
  'payment_status.DYN.9': 'Готово к оплате по прибытии',
  'payment_status.DYN.9.entry': 'Готово к регистрации',
  'payment_status.DYN.9.exit': 'Готово к выезду',
  'payment_status.DYN.2': 'Выезд завершен',
  'payment_status.DYN.3': 'Дублировано',
  'payment_status.DYN.4': 'Возвращено',
  'payment_status.DYN.5': 'Отклонено',
  'payment_status.extension.DYN.5': 'Продление отклонено',
  'payment_status.DYN.5.blacklisted': 'Отклонено - В черном списке',
  'createPeople.success.DYN.': 'Заявитель успешно создан',
  'adminRequestResult.title.DYN.': 'Выбранное заявление - {paymentID}',
  'form.paymentType': 'Тип платежа',
  'payment.type.online': 'Онлайн',
  'payment.type.offline': 'Офлайн',
  'request.state.DYN.': 'Статус заявления',
  'form.birthDate': 'Дата рождения',
  'form.birthCountry': 'Страна рождения',
  'form.placeOfBirth': 'Город рождения',
  'form.residenceAdress': 'Адрес проживания',
  'form.maritalStatus': 'Семейное положение',
  'form.departureDate': 'Дата выезда',
  'form.arrivalDate': 'Дата прибытия',
  'form.referencePreviousVisa': 'Ссылка на предыдущую визу',
  'form.passportNumber': 'Номер паспорта',
  'form.hostName': 'Имя хозяина',
  'form.purposeOfVisit': 'Цель визита',
  'form.previousConvictionsHome': 'Предыдущие судимости в стране проживания',
  'form.spouse.birthDay': 'Дата рождения супруга(и)',
  'form.spousePassportNumber': 'Номер паспорта супруга(и)',
  'form.spousePlaceOfBirth': 'Место рождения супруга(и)',
  'form.dependantFullName': 'Полное имя зависимого',
  'form.dependantPassportNumber': 'Номер паспорта зависимого',
  'form.dependantPlaceOfBirth': 'Место рождения зависимого',
  'form.dependantBirthDay': 'Дата рождения зависимого',
  'form.existingValidEntryReferenceOfficer': 'Сотрудник по ссылке на въезд',
  'officer.unknown': 'Неизвестный сотрудник',
  'global.approve': 'Одобрить',
  'global.refuse': 'Отклонить',
  'global.suspend': 'Запросить пересмотр',
  'personal.data': 'Личные данные',
  'contact.data': 'Контактные данные',
  'divers.data.DYN.': 'Детали путешествия',
  'dependant.data': 'Данные зависимых',
  'spouse.data': 'Данные супруга(и)',
  'payment.review.approve.ask.DYN.': 'Вы действительно хотите рассмотреть это визовое заявление как <b>РЕКОМЕНДУЕМОЕ</b>?',
  'payment.review.refuse.ask.DYN.': 'Вы действительно хотите рассмотреть это визовое заявление как <b>НЕ РЕКОМЕНДУЕМОЕ</b>?',
  'payment.review.refuse.ask.extension.DYN.': 'Вы действительно хотите рассмотреть этот запрос на продление как <b>НЕ РЕКОМЕНДУЕМОЕ</b>?',
  'payment.review.approve.extension.ask.DYN.': 'Вы действительно хотите <b>ОДОБРИТЬ</b> этот запрос на продление?',
  'payment.validate.ask.DYN.': 'Вы действительно хотите <b>ОДОБРИТЬ</b> это визовое заявление?',
  'payment.validate.extension.ask.DYN.': 'Вы действительно хотите <b>ОДОБРИТЬ</b> этот запрос на продление?',
  'error.payment.suspend.error.DYN.': 'Произошла ошибка при приостановке визового заявления.',
  'global.no': 'Нет',
  'global.Yes': 'Да',
  'global.No': 'Нет',
  'documents': 'Документы',
  'data.biographic': 'Биографическая страница паспорта',
  'residence.proof': 'Доказательство проживания',
  'address.destination': 'Адрес назначения',
  'previous.visa': 'Предыдущая виза',
  'invite.letter': 'Пригласительное письмо',
  'hostInvitation.letter': 'Пригласительное письмо хозяина',
  'proof.residenceHost': 'Доказательство проживания хозяина',
  'hostResidential.status': 'Статус проживания хозяина',
  'reasonOfVisit.proof': 'Доказательство причины визита в страну назначения',
  'inviteBusiness.letter': 'Бизнес-письмо компании отправителя',
  'business.profile': 'Профессиональный профиль путешественника',
  'application.letter': 'Письмо-заявление на визу',
  'acceptanceFromScool.letter': 'Письмо-подтверждение',
  'date.creation': 'Дата создания',
  'document.Passport': 'Паспорт',
  'completeName': 'Полное имя',
  'price': 'Цена',
  'global.retry': 'Повторить попытку',
  'err.loginWeak': 'Проблема с подключением, попробуйте снова',
  'URGENTPASS.title': 'Срочный паспорт',
  'refusalReason': 'Причина отказа',
  'error.payment.noRefuseReason': 'Пожалуйста, введите сообщение.',
  'error.payment.noSuspendReason': 'Пожалуйста, введите причину приостановки. Эта причина будет отправлена клиенту.',
  'refusal.desc.DYN.': 'Это визовое заявление было отклонено.',
  'refusal.desc.extension.DYN.': 'Этот запрос на продление был отклонен.',
  'approval.desc.DYN.': 'Это визовое заявление было одобрено.',
  'approval.desc.extension.DYN.': 'Этот запрос на продление был одобрен.',
  'review.approval.desc.DYN.': 'Это визовое заявление соответствует требованиям.',
  'review.approval.desc.extension.DYN.': 'Этот запрос на продление соответствует требованиям.',
  'review.refusal.desc.DYN.': 'Это визовое заявление не соответствует требованиям.',
  'review.refusal.desc.extension.DYN.': 'Этот запрос на продление не соответствует требованиям.',
  'err.getUsers: client.extended.notActiveToken': 'Ваша сессия истекла. Пожалуйста, войдите снова.',
  'VISA_DOUBLE.title': 'Виза для двукратного въезда',
  'VISA_KAZA.title': 'Виза Kaza',
  'history': 'История',
  'menu.people.DYN.': 'Сохраненные заявители',
  'DYN.XBA': 'Африканский банк развития',
  'DYN.AGO': 'Ангола',
  'DYN.ABW': 'Аруба',
  'DYN.ATG': 'Антигуа и Барбуда',
  'DYN.BHS': 'Багамы',
  'DYN.BRB': 'Барбадос',
  'DYN.BLZ': 'Белиз',
  'DYN.BWA': 'Ботсвана',
  'DYN.CYM': 'Каймановы острова',
  'DYN.CYP': 'Кипр',
  'DYN.FJI': 'Фиджи',
  'DYN.COD': 'Демократическая Республика Конго',
  'DYN.GHA': 'Гана',
  'DYN.GRD': 'Гренада',
  'DYN.HKG': 'Гонконг (специальный административный район Китая)',
  'DYN.KEN': 'Кения',
  'DYN.KIR': 'Кирибати',
  'DYN.JAM': 'Ямайка',
  'DYN.LDW': 'Острова Подветренные',
  'DYN.LSO': 'Лесото',
  'DYN.MDG': 'Мадагаскар',
  'DYN.MWI': 'Малави',
  'DYN.MYS': 'Малайзия',
  'DYN.MDV': 'Мальдивы',
  'DYN.MLT': 'Мальта',
  'DYN.MUS': 'Маврикий',
  'DYN.MSR': 'Монтсеррат',
  'DYN.MOZ': 'Мозамбик',
  'DYN.NAM': 'Намибия',
  'DYN.NRU': 'Науру',
  'DYN.LCA': 'Сент-Люсия',
  'DYN.VCT': 'Сент-Винсент и Гренадины',
  'DYN.WSM': 'Западное Самоа',
  'DYN.SYC': 'Сейшельские острова',
  'DYN.SGP': 'Сингапур',
  'DYN.SLB': 'Соломоновы острова',
  'DYN.ZAF': 'Южно-Африканская Республика',
  'DYN.KNA': 'Сент-Китс и Невис',
  'DYN.SWZ': 'Свазиленд',
  'DYN.TON': 'Тонга',
  'DYN.TTO': 'Тринидад и Тобаго',
  'DYN.TCA': 'Острова Теркс и Кайкос',
  'DYN.TUV': 'Тувалу',
  'DYN.UGA': 'Уганда',
  'DYN.TZA': 'Объединенная Республика Танзания',
  'DYN.VUT': 'Вануату',
  'DYN.VAT': 'Ватикан',
  'DYN.VEN': 'Венесуэла (Боливарианская Республика)',
  'DYN.USA': 'Соединенные Штаты Америки',
  'DYN.URY': 'Уругвай',
  'DYN.UZB': 'Узбекистан',
  'DYN.UKR': 'Украина',
  'DYN.ARE': 'Объединенные Арабские Эмираты',
  'DYN.GBR': 'Великобритания',
  'DYN.TUR': 'Турция',
  'DYN.TKM': 'Туркменистан',
  'DYN.SWE': 'Швеция',
  'DYN.CHE': 'Швейцария',
  'DYN.TJK': 'Таджикистан',
  'DYN.KAZ': 'Казахстан',
  'DYN.SUR': 'Суринам',
  'DYN.ESP': 'Испания',
  'DYN.SVK': 'Словакия',
  'DYN.SVN': 'Словения',
  'DYN.SEN': 'Сенегал',
  'DYN.SRB': 'Сербия',
  'DYN.SMR': 'Сан-Марино',
  'DYN.STP': 'Сан-Томе и Принсипи',
  'DYN.NLD': 'Нидерланды',
  'DYN.NCL': 'Новая Каледония',
  'DYN.NZL': 'Новая Зеландия',
  'DYN.NIC': 'Никарагуа',
  'DYN.MEX': 'Мексика',
  'DYN.FSM': 'Федеративные Штаты Микронезии',
  'DYN.MDA': 'Молдова',
  'DYN.MCO': 'Монако',
  'DYN.MHL': 'Маршалловы острова',
  'DYN.LVA': 'Латвия',
  'DYN.NFK': 'Остров Норфолк',
  'DYN.MNP': 'Северные Марианские острова',
  'DYN.NOR': 'Норвегия',
  'DYN.PLW': 'Палау',
  'DYN.PSE': 'Палестина',
  'DYN.PAN': 'Панама',
  'DYN.PNG': 'Папуа-Новая Гвинея',
  'DYN.PRY': 'Парагвай',
  'DYN.PER': 'Перу',
  'DYN.POL': 'Польша',
  'DYN.PRT': 'Португалия',
  'DYN.PRI': 'Пуэрто-Рико',
  'DYN.REU': 'Реюньон',
  'DYN.ROU': 'Румыния',
  'DYN.RUS': 'Россия',
  'DYN.RWA': 'Руанда',
  'DYN.LIE': 'Лихтенштейн',
  'DYN.LTU': 'Литва',
  'DYN.LUX': 'Люксембург',
  'DYN.MAC': 'Макао (специальный административный район Китая)',
  'DYN.JPN': 'Япония',
  'DYN.KWT': 'Кувейт',
  'DYN.KGZ': 'Кыргызстан',
  'DYN.KOR': 'Южная Корея',
  'DYN.GUY': 'Гайана',
  'DYN.HTI': 'Гаити',
  'DYN.HND': 'Гондурас',
  'DYN.IRL': 'Ирландия',
  'DYN.ISR': 'Израиль',
  'DYN.ITA': 'Италия',
  'DYN.HUN': 'Венгрия',
  'DYN.ISL': 'Исландия',
  'DYN.IND': 'Индия',
  'DYN.IDN': 'Индонезия',
  'DYN.IRN': 'Иран',
  'DYN.GUM': 'Гуам',
  'DYN.GTM': 'Гватемала',
  'DYN.GIB': 'Гибралтар',
  'DYN.GRC': 'Греция',
  'DYN.GEO': 'Грузия',
  'DYN.DEU': 'Германия',
  'DYN.DNK': 'Дания',
  'DYN.EST': 'Эстония',
  'DYN.ETH': 'Эфиопия',
  'DYN.FIN': 'Финляндия',
  'DYN.FRA': 'Франция',
  'DYN.GUF': 'Французская Гвиана',
  'DYN.PYF': 'Французская Полинезия',
  'DYN.ATF': 'Южные и Антарктические территории Франции',
  'DYN.CZE': 'Чехия',
  'DYN.COM': 'Коморы',
  'DYN.DOM': 'Доминиканская Республика',
  'DYN.ECU': 'Эквадор',
  'DYN.EGY': 'Египет',
  'DYN.SLV': 'Сальвадор',
  'DYN.GNQ': 'Экваториальная Гвинея',
  'DYN.CHL': 'Чили',
  'DYN.CHN': 'Китай',
  'DYN.CHN_NT': 'Китай (не туристический)',
  'DYN.COK': 'Острова Кука',
  'DYN.CRI': 'Коста-Рика',
  'DYN.HRV': 'Хорватия',
  'DYN.CUB': 'Куба',
  'DYN.BDI': 'Бурунди',
  'DYN.CAN': 'Канада',
  'DYN.CPV': 'Кабо-Верде',
  'DYN.BRA': 'Бразилия',
  'DYN.VGB': 'Британские Виргинские острова',
  'DYN.BRN': 'Бруней-Даруссалам',
  'DYN.BGR': 'Болгария',
  'DYN.BMU': 'Бермуды',
  'DYN.BTN': 'Бутан',
  'DYN.BIH': 'Босния и Герцеговина',
  'DYN.BLR': 'Беларусь',
  'DYN.BEL': 'Бельгия',
  'DYN.BHR': 'Бахрейн',
  'DYN.ARG': 'Аргентина',
  'DYN.ARM': 'Армения',
  'DYN.AUS': 'Австралия',
  'DYN.AUT': 'Австрия',
  'DYN.AZE': 'Азербайджан',
  'DYN.ALB': 'Албания',
  'DYN.DZA': 'Алжир',
  'DYN.AIA': 'Ангилья',
  'DYN.BGD': 'Бангладеш',
  'DYN.BEN': 'Бенин',
  'DYN.AFG': 'Афганистан',
  'DYN.BOL': 'Боливия',
  'DYN.BFA': 'Буркина-Фасо',
  'DYN.KHM': 'Камбоджа',
  'DYN.CMR': 'Камерун',
  'DYN.CIV': 'Кот-д\'Ивуар',
  'DYN.CAF': 'Центральноафриканская Республика',
  'DYN.TCD': 'Чад',
  'DYN.COL': 'Колумбия',
  'DYN.ERI': 'Эритрея',
  'DYN.COG': 'Республика Конго',
  'DYN.PRK': 'Корейская Народно-Демократическая Республика',
  'DYN.GAB': 'Габон',
  'DYN.GMB': 'Гамбия',
  'DYN.DJI': 'Джибути',
  'DYN.GIN': 'Гвинея',
  'DYN.GNB': 'Гвинея-Бисау',
  'DYN.IRQ': 'Ирак',
  'DYN.KOS': 'Косово',
  'DYN.LAO': 'Лаос',
  'DYN.JOR': 'Иордания',
  'DYN.LBR': 'Либерия',
  'DYN.LBY': 'Ливийская Арабская Джамахирия',
  'DYN.MLI': 'Мали',
  'DYN.QAT': 'Катар',
  'DYN.REF': 'Беженец',
  'DYN.PHL': 'Филиппины',
  'DYN.OMN': 'Оман',
  'DYN.PAK': 'Пакистан',
  'DYN.LBN': 'Ливан',
  'DYN.MRT': 'Мавритания',
  'DYN.MNG': 'Монголия',
  'DYN.MNE': 'Черногория',
  'DYN.NER': 'Нигер',
  'DYN.NGA': 'Нигерия',
  'DYN.MMR': 'Мьянма',
  'DYN.MAR': 'Марокко',
  'DYN.NPL': 'Непал',
  'DYN.SAU': 'Саудовская Аравия',
  'DYN.SLE': 'Сьерра-Леоне',
  'DYN.SOM': 'Сомали',
  'DYN.LKA': 'Шри-Ланка',
  'DYN.SSD': 'Южный Судан',
  'DYN.SDN': 'Судан',
  'DYN.THA': 'Таиланд',
  'DYN.MKD': 'Бывшая Югославская Республика Македония',
  'DYN.TGO': 'Того',
  'DYN.SYR': 'Сирийская Арабская Республика',
  'DYN.TWN': 'Тайвань',
  'DYN.TUN': 'Тунис',
  'DYN.VNM': 'Вьетнам',
  'DYN.YEM': 'Йемен',
  'DYN.TLS': 'Тимор-Лесте',
  'DYN.AND': 'Андорра',
  'DYN.VIR': 'Виргинские острова (США)',
  'DYN.XKX': 'Косово',
  'DYN.ZWE': 'Зимбабве',
  'DYN.ZMB': 'Замбия',
  'DYN.ASM': 'Американское Самоа',
  'DYN.DMA': 'Доминика',
  'DYN.XXA': 'Лицо без гражданства',
  'DYN.XXB': 'Беженец (Женевская конвенция)',
  'DYN.XXC': 'Беженец (Другие)',
  'DYN.UNA': 'Агентство Организации Объединенных Наций',
  'DYN.UNO': 'Организация Объединенных Наций',
  'document.type.DYN.': 'Тип заявки',
  'dependantIndex': 'Зависимый {index}',
  'form.spouseFullName': 'Полное имя супруга',
  'qrDesc.valid': 'Предъявите этот QR-код на пункте визового контроля при въезде/выезде из страны. Вы не можете путешествовать без действительного QR-кода.',
  'err.pay': 'Произошла ошибка во время оплаты. Попробуйте снова.',
  'payment.noEvents': 'В настоящее время это заявление не содержит каких-либо событий, связанных с путешествием (использование заявки).',
  'global.cancel': 'Отмена',
  'end.suspend': 'Завершить исправление',
  'trips.title': 'Отслеживание заявлений',
  'trips.desc': 'Заявление(я)',
  'BatchId': 'Ссылка на заявление',
  'newBatchId.desc': 'Введите имя для этого путешествия.',
  'personLinkType.DYN.0': 'Неизвестно',
  'personLinkType.DYN.1': 'Ребенок',
  'personLinkType.DYN.2': 'Родитель',
  'personLinkType.DYN.3': 'Супруг(а)',
  'personLinkType.DYN.4': 'Другоe',
  'personLinkType.DYN.5': 'Я сам',
  'batchIds.desc': 'Заявления, связанные с поездкой {trip} :',
  'trip.name': 'Ссылка на заявление',
  'visaIntro.validFrom': 'Дата начала',
  'visaIntro.validUntil': 'Дата окончания',
  'visaIntro.usageCount': 'Количество разрешенных использований',
  'client.extended.passportNumberAlreadyExists': 'Этот номер паспорта уже используется. Пожалуйста, введите другой.',
  'client.extended.alreadyDecided': 'Вы уже рассматривали эту визовую заявку. Повторное рассмотрение невозможно.',
  'client.extended.outOfUsage': 'Эта заявка <b>вышла за пределы периода действия</b>',
  'global.review': 'Обзор',
  'error.review.noChoice': 'Пожалуйста, выберите состояние обзора, чтобы продолжить.',
  'all.reviews': 'Все обзоры этой визовой заявки',
  'all.reviews.extension': 'Все обзоры этого запроса на продление',
  'validate.desc': 'Эта заявка была одобрена {date} пользователем',
  'validate.extension.desc': 'Этот запрос на продление был одобрен {date} пользователем',
  'refusal.review.desc': 'Эта заявка была отклонена {date} пользователем',
  'refusal.review.extension.desc': 'Этот запрос на продление был отклонен {date} пользователем',
  'refusal.review.desc.blacklisted': 'Эта заявка была отклонена и занесена в черный список {date} пользователем',
  'approve.text': 'Эта заявка была одобрена.',
  'pending.review.desc': 'Коррекция этой визовой заявки была запрошена у заявителя {date} пользователем',
  'global.reason': 'Причина',
  'pending.desc': 'Эта заявка в настоящее время ожидает исправления от клиента.',
  'successRequest.title': 'Заявка успешно отправлена',
  'amountDue': 'Цена: ',
  'amountDue.total.now': 'Итоговая сумма сейчас: ',
  'amountDue.total.later': 'Итоговая сумма на стойке офицера: ',
  'noPrint.mobile': 'Печать страницы не поддерживается на мобильных устройствах',
  'onArrival.reset': 'Начать новый процесс',
  'onArrival.reset.ask': 'Вы действительно хотите начать новый процесс?',
  'stillHere': 'Вы все еще здесь? Этот процесс сбросится через 20 секунд.',
  'print.request': 'Распечатать заявку',
  'EXPIRED.globalExplain': 'Эта заявка была отклонена. Она не соответствует нашим стандартам.',
  'payment_status.desc.DYN.7': 'Эта заявка ожидает исправления от клиента.',
  'payment_status.DYN.6.review': 'Ожидает рассмотрения - {reviewCount}/2',
  'payment_status.extension.DYN.6': 'Ожидает рассмотрения',
  'payment_status.extension.DYN.6.review': 'Ожидает рассмотрения - {reviewCount}/1',
  'payment_status.desc.DYN.6.review': 'Эта заявка в настоящее время ожидает рассмотрения. Она уже была рассмотрена {reviewCount} раз(а).',
  'payment_status.DYN.6.finalReview': 'Ожидает окончательного рассмотрения',
  'payment_status.extension.DYN.6.finalReview': 'Ожидает окончательного рассмотрения',
  'payment_status.desc.DYN.6.finalReview': 'Эта заявка была рассмотрена и в настоящее время ожидает окончательного рассмотрения.',
  'payment_status.desc.DYN.0': 'Эта заявка в настоящее время ожидает проверки оплаты в платежном учреждении. Если платеж еще не был произведен, его можно завершить сейчас.',
  'payment_status.desc.DYN.5': 'Эта заявка была отклонена.',
  'payment_status.desc.DYN.5.blacklisted': 'Эта заявка была отклонена, и человек был занесен в черный список.',
  'payment_status.desc.DYN.5.checkIn': 'Эта заявка была отклонена при регистрации на стойке офицера.',
  'payment_status.desc.DYN.5.checkIn.reason': 'Эта заявка была отклонена при регистрации на стойке офицера. <p><b>Причина</b>: <br/> {reason}</p>',
  'payment_status.DYN.5.checkIn': 'Отклонено при регистрации',
  'payment_status.desc.DYN.5.checkOut': 'Эта заявка была отклонена при выезде на стойке офицера.',
  'payment_status.DYN.5.checkOut': 'Отклонено при выезде',
  'payment_status.desc.DYN.9': 'Эта заявка готова к оплате на стойке офицера. Регистрация может быть завершена после оплаты.',
  'payment_status.desc.DYN.9.entry': 'Эта заявка готова к регистрации на стойке офицера.',
  'payment_status.desc.DYN.9.exit': 'Эта заявка готова к выезду и требует оплаты за пропуск на границе, выданный на стойке офицера.',
  'payment_status.DYN.2.out': 'Готово к выезду',
  'payment_status.DYN.2.outFinish': 'Выезд завершен',
  'payment_status.DYN.2.closed': 'Закрыто',
  'payment_status.desc.DYN.2.closed': 'Эта заявка была закрыта.',
  'payment_status.desc.DYN.2.zweexit': 'Эта заявка готова к выезду на стойке офицера.',
  'payment_status.DYN.2.entryFinish': 'Регистрация завершена',
  'payment_status.DYN.2.in': 'Готово к регистрации',
  'payment_status.desc.DYN.2.out': 'Эта заявка была зарегистрирована. Следующий шаг - выезд на стойке офицера.',
  'payment_status.desc.DYN.2.outFinish': 'Эта заявка была завершена. Клиент может теперь путешествовать.',
  'payment_status.desc.DYN.2.entryFinish': 'Эта заявка была зарегистрирована. Клиент теперь может въехать в страну.',
  'payment_status.desc.DYN.2.in': 'Эта заявка ожидает регистрации на стойке офицера.',
  'payment_status.DYN.zwevisa.6.review': 'Ожидает рассмотрения - {reviewCount}/2',
  'payment_status.extension.DYN.zwevisa.6': 'Ожидает рассмотрения',
  'payment_status.extension.DYN.zwevisa.6.review': 'Ожидает рассмотрения - {reviewCount}/1',
  'payment_status.desc.DYN.zwevisa.6.review': 'Эта визовая заявка в настоящее время ожидает рассмотрения. Она уже была рассмотрена {reviewCount} раз(а).',
  'payment_status.DYN.zwevisa.6.finalReview': 'Ожидает окончательного рассмотрения',
  'payment_status.extension.DYN.zwevisa.6.finalReview': 'Ожидает окончательного рассмотрения',
  'payment_status.desc.DYN.zwevisa.6.finalReview': 'Эта визовая заявка была рассмотрена и в настоящее время ожидает окончательного рассмотрения.',
  'payment_status.desc.DYN.zwevisa.0': 'Эта заявка в настоящее время ожидает проверки оплаты в платежном учреждении. Если платеж еще не был произведен, его можно завершить сейчас.',
  'payment_status.desc.DYN.zwevisa.7': 'Эта визовая заявка ожидает исправления от клиента.',
  'payment_status.desc.DYN.zwevisa.5': 'Эта визовая заявка была отклонена.',
  'payment_status.desc.DYN.zwevisa.5.expired': 'Срок действия этой визовой заявки истек.',
  'payment_status.desc.extension.DYN.zwevisa.5': 'Этот запрос на продление был отклонен.',
  'payment_status.desc.DYN.zwevisa.5.blacklisted': 'Эта визовая заявка была отклонена, и человек был занесен в черный список.',
  'payment_status.desc.DYN.zwevisa.5.checkIn': 'Эта заявка была отклонена при регистрации на стойке офицера.',
  'payment_status.desc.DYN.zwevisa.5.checkIn.reason': 'Эта заявка была отклонена при регистрации на стойке офицера. <p><b>Причина</b>: <br/> {reason}</p>',
  'payment_status.DYN.zwevisa.5.checkIn': 'Отклонено при регистрации',
  'payment_status.desc.DYN.zwevisa.5.checkOut': 'Эта заявка была отклонена при выезде на стойке офицера.',
  'payment_status.DYN.zwevisa.5.checkOut': 'Отклонено при выезде',
  'payment_status.desc.DYN.zwevisa.9': 'Эта визовая заявка готова к оплате на стойке офицера. Регистрация может быть завершена после оплаты.',
  'payment_status.desc.DYN.zwevisa.9.entry': 'Эта заявка готова к регистрации на стойке офицера.',
  'payment_status.desc.DYN.zwevisa.9.exit': 'Эта заявка готова к выезду и требует оплаты за пропуск на границе, выданный на стойке офицера.',
  'payment_status.DYN.zwevisa.2.out': 'Готово к выезду',
  'payment_status.DYN.zwevisa.2.outFinish': 'Выезд завершен',
  'payment_status.DYN.zwevisa.2.closed': 'Закрыто',
  'payment_status.desc.DYN.zwevisa.2.closed': 'Эта заявка была закрыта.',
  'payment_status.desc.DYN.zwevisa.2.zweexit': 'Эта заявка готова к выезду на стойке офицера.',
  'payment_status.DYN.zwevisa.2.entryFinish': 'Регистрация завершена',
  'payment_status.DYN.zwevisa.2.in': 'Готово к регистрации',
  'payment_status.desc.DYN.zwevisa.2.out': 'Эта заявка была зарегистрирована. Следующий шаг - выезд на стойке офицера.',
  'payment_status.desc.DYN.zwevisa.2.outFinish': 'Эта заявка была завершена. Клиент может теперь путешествовать.',
  'payment_status.desc.DYN.zwevisa.2.entryFinish': 'Эта заявка была зарегистрирована. Клиент теперь может въехать в страну.',
  'payment_status.desc.DYN.zwevisa.2.in': 'Эта заявка ожидает регистрации на стойке офицера.',
  'ask.isArrivalPaid': 'Следующий платеж должен быть оплачен сейчас в любой из следующих валют:',
  'ask.isArrivalPaid.exit': 'Граничный пропуск должен быть оплачен сейчас в любой из следующих валют:',
  'ask.isArrivalPaid.confirm': 'Вы подтверждаете, что платеж был выполнен? Если да, пожалуйста, введите ссылку на платеж, способ оплаты и используемую валюту. Вы также можете изменить максимальную дату окончания пребывания (можно только уменьшить дату, выбрав от 1 до {days} дней).',
  'ask.isArrivalPaid.confirm.exit': 'Подтверждаете ли вы, что платеж был произведен? Если вы подтверждаете, пожалуйста, введите ссылку на платеж и используемую валюту.',
  'ask.checkoutExpired.confirm': 'Подтверждаете ли вы, что платеж был произведен? Если вы подтверждаете, пожалуйста, введите ссылку на платеж и используемую валюту.',
  'no_trips': 'У вас нет путешествий.',
  'err.canActivate': 'Произошла ошибка',
  'form.passportNumber.dateOfIssue': 'Дата выдачи паспорта',
  'form.passportNumber.dateOfExpiry': 'Дата истечения срока действия паспорта',
  'form.passportNumber.placeOfIssue': 'Место выдачи паспорта',
  'nextOfKin.data': 'Экстренный контакт / Ближайший родственник',
  'form.otherLinkType': 'Укажите тип родственной связи',
  'camera.problem.manual': 'Вы собираетесь зарегистрировать/вывести эту визовую заявку без фотографии клиента. Вы уверены, что хотите продолжить?',
  'camera.problem.button': 'Проблема с камерой?',
  'global.noFilter': '--Без фильтра--',
  'zweentry': 'Въезд без визы',
  'zweentry.title': 'Въезд без визы',
  'free.charge': 'Бесплатно',
  'camera.init.error': 'Произошла ошибка при инициализации камеры. Вы хотите зарегистрировать/вывести эту заявку без фотографии клиента?',
  'error.payment.noPaymentReference': 'Пожалуйста, введите ссылку на платеж, метод оплаты и используемую валюту.',
  'paymentReference.ask': 'Ссылка на платеж',
  'paymentReference.askExpired': 'Ссылка на платеж за просрочку',
  'session.expired': 'Ваша сессия истекла. Пожалуйста, войдите снова.',
  'phone.pattern': ' (например: +263771234567)',
  'global.receipt.id': 'ID заявки: {paymentId}',
  'ask.place.updatePermissions': 'Вы уверены, что хотите обновить права доступа для этого места?',
  'place.updatePermissions.success': 'Права доступа для этого места были успешно обновлены.',
  'err.place.updatePermissions': 'Произошла ошибка при обновлении прав доступа для этого места.',
  'global.urgent': 'Срочно',
  'form.usageAfter': 'Действительно с',
  'form.usageUntil': 'Действительно до',
  'form.localUsageUntil': 'Максимальная дата окончания пребывания',
  'form.timeslot': 'Временные интервалы',
  'internalReference': 'Ссылка HQ',
  'payment_status.DYN.6.0': 'Ожидание рассмотрения 0/2',
  'payment_status.DYN.6.1': 'Ожидание рассмотрения 1/2',
  'payment_status.DYN.6.2': 'Ожидание окончательного рассмотрения',
  'payment_status.DYN.8.0': 'Оплата позже - не подтверждено',
  'payment_status.DYN.2.0': 'Регистрация завершена',
  'payment_status.DYN.2.4': 'Готово к выезду',
  'payment_status.DYN.2.5': 'Выезд завершен',
  'payment_status.DYN.2.6': 'Отклонено при регистрации',
  'payment_status.DYN.2.7': 'Отклонено при выезде',
  'payment_status.DYN.2.8': 'Закрыто',
  'payment_status.extension.DYN.6.0': 'Oжидание рассмотрения 0/1',
  'payment_status.extension.DYN.6.2': 'Oжидание окончательного рассмотрения',
  'payment_status.extension.DYN.7': 'Ожидает исправления',
  'payment_status.extension.DYN.9': 'Продление подтверждено',
  'payment_status.extension.DYN.0': 'Ожидает оплаты',
  'internalReference.create': 'Добавить ссылку HQ',
  'internalReference.edit': 'Редактировать ссылку HQ',
  'timeslot.set': 'Установить временной слот',
  'timeslot.setNew': 'Установить новый временной слот',
  'internalReference.ask.edit': 'Пожалуйста, введите новую ссылку HQ.',
  'internalReference.ask.create': 'Пожалуйста, введите ссылку HQ.',
  'internalReference.done.create': 'Ссылка HQ была успешно добавлена.',
  'internalReference.done.edit': 'Ссылка HQ была успешно отредактирована.',
  'error.internalReference': 'Произошла ошибка при добавлении/редактировании ссылки HQ.',
  'error.paymentUntil.expired': 'Эта заявка вышла за пределы срока действия. Вы можете продолжить процесс выезда клиента; однако, пожалуйста, учтите, что взимается плата в размере 100 долларов США из-за просроченного статуса визовой заявки. Оплата должна быть произведена немедленно в любой из следующих валют:',
  'internalReference.desc': 'Добавить ссылку HQ к этой заявке (например, 140_2024).',
  'titlePrint': 'Визовая заявка </br> <b>{paymentID}</b>',
  'title.visaReference': 'Связанное заявление',
  'titlePrint.extension': 'Запрос на продление </br> <b>{paymentID}</b>',
  'globalStatus.valid': 'Действительно',
  'PENDING.globalExplain': 'Этот запрос ожидает исправления. Пожалуйста, проверьте информацию и исправьте ее.',
  'PAID_NOT_CONFIRMED.globalExplain': 'Этот запрос ожидает подтверждения нашими службами.',
  'PROPOSED.globalExplain': 'Этот запрос ожидает оплаты. Если вы еще не подтвердили оплату, вы можете сделать это сейчас.',
  'afterWithoutUntil': 'Вы можете въехать с {dateAfter} до {deadlineDate}.',
  'afterWithoutUntilAndMillis': 'Вы можете начать путешествие с {dateAfter}.',
  'afterAndUntil': 'Вы можете начать путешествие с {dateAfter} до {dateUntil}.',
  'photo.current': 'Текущая фотография',
  'photo.scanned': 'Фотография, отсканированная из паспорта',
  'createdAt': 'Дата создания',
  'all.infos': 'Информация о заявке',
  'afterRefused': 'Заявленные даты путешествия: {dateAfter}.',
  'DYN.paymentError.desc.success': `<p>Ваше заявление было успешно зарегистрировано. Если какая-либо часть этого заявления требует одобрения со стороны департамента иммиграции, вы будете уведомлены, как только этот процесс будет завершен. В противном случае знайте, что мы получили ваше заявление.</p>
    <p><b>Спасибо, что воспользовались нашими услугами.</b></p>`,
  'sinceOneWeek': 'Обратите внимание, что этот документ находится в статусе ожидания рассмотрения более одной недели.',
  'client.extended.onlyAdminDecide': 'Эта заявка уже была рассмотрена сотрудником с таким же уровнем старшинства, как у вас. Повторное рассмотрение невозможно.',
  'error.paymentUntil.before': 'Дата слишком ранняя. Эта заявка будет действительна с {dateAfter}.',
  'applicant.gender.FEMALE': 'Женский',
  'applicant.gender.MALE': 'Мужской',
  'entry.consume': 'Въезды',
  'exit.consume': 'Выезды',
  'scan.noConsumeMode': 'Как пограничный офицер, вы должны управлять как въездами, так и выездами. Пожалуйста, выберите опцию, соответствующую вашей текущей задаче: обработка въездов или управление выездами.',
  'scan.noVisaFound': 'Для этого человека не найдено записи в статусе "Готов к выезду". Хотите создать запись, готовую к выезду?',
  'zweexit': 'Выезд без визы',
  'err.scanPassport': 'Произошла ошибка при сканировании паспорта. Пожалуйста, убедитесь, что он правильно вставлен, и попробуйте снова. Если проблема сохраняется, перезагрузите приложение или свяжитесь с поддержкой.',
  'exit.register': 'Зарегистрировать выезд',
  'entry.register': 'Зарегистрировать въезд',
  'exit.create': 'Создать выезд без визы',
  'exit.ask': 'Вы уверены, что хотите зарегистрировать выезд без визы для этого человека?',
  'border': 'Пограничный офицер',
  'global.signout': 'Выйти',
  'search.manually': 'Поиск заявки',
  'scan.applicationQr': 'Сканировать QR заявки',
  'err.client.extended.maxUsageCountReached': 'Достигнуто максимальное количество использований этой заявки.',
  'form.firstName.scanned': 'Отсканированное имя',
  'form.lastName.scanned': 'Отсканированная фамилия',
  'form.documentNumber.scanned': 'Отсканированный номер паспорта',
  'form.gender.scanned': 'Отсканированный пол',
  'form.birthDate.scanned': 'Отсканированная дата рождения',
  'form.nationality.scanned': 'Отсканированное гражданство',
  'form.nationality': 'Гражданство',
  'application.data': 'Данные заявки',
  'no.passportPhoto': 'Нет фотографии',
  'overstay': 'Превышение срока пребывания',
  'method.payment': 'Метод оплаты',
  'review.desc': 'Одобрить/Отклонить',
  'approval.usageUntil.DYN.': 'Изменить дату истечения срока действия (необязательно)',
  'scanned.list': 'Список найденных заявок',
  'scanned.recommended': 'Рекомендовано',
  'scanned.entriesUsed': 'записей использовано',
  'scanned.paid': 'Оплачено',
  'visa.blacklist': 'Эта визовая заявка была занесена в черный список. Человеку запрещен въезд в страну.',
  'scan.noEntryFound': 'Для этого человека не найдено записи в статусе "Готов к регистрации". Хотите создать запись, готовую к регистрации?',
  'global.syncing': 'Синхронизация...',
  'payment.consume.error.DYN.': 'Произошла ошибка при обработке заявки.',
  'tooltip.changeTimeslot': 'Изменить временной слот',
  'tooltip.transit': 'Установите этот флажок, чтобы управлять транзитом в качестве пограничника.',
  'tooltip.Qr': 'Вы можете напрямую сканировать QR-код, связанный с заявкой, чтобы найти подробную информацию о ней.',
  'tooltip.arrivals': 'Отметьте этот флажок, чтобы управлять въездами как пограничный офицер.',
  'tooltip.departures': 'Отметьте этот флажок, чтобы управлять выездами как пограничный офицер.',
  'tooltip.searchManually': 'Найдите конкретную заявку, используя различные критерии.',
  'tooltip.signout': 'Выйти из приложения.',
  'tooltip.my_account': 'Доступ к настройкам вашей учетной записи.',
  'tooltip.dashboard': 'Доступ к панели управления.',
  'tooltip.createRequests': 'Создание нового заявление.',
  'tooltip.trips': 'Просмотр статуса ваших заявлений и печать связанных документов, если они одобрены.',
  'tooltip.people': 'Управление заявителями, связанными с вашей учетной записью.',
  'tooltip.users': 'Управляйте пользователями приложения.',
  'tooltip.places': 'Управляйте местами в приложении.',
  'tooltip.role': 'Ваша роль и имя в приложении.',
  'tooltip.exitRegister': 'Вручную зарегистрировать выезд без визы для человека.',
  'tooltip.entryRegister': 'Вручную зарегистрировать въезд без визы для человека.',
  'tooltip.support': 'Свяжитесь с поддержкой для получения помощи в случае возникновения проблем.',
  'tooltip.chooseLang': 'Изменить язык приложения. В настоящее время доступен только английский.',
  'tooltip.changePassword': 'Изменить ваш пароль.',
  'tooltip.internalReferenceNoFilter': 'Нажмите на внутреннюю ссылку, если она доступна, чтобы перейти по связанной ссылке.',
  'tooltip.state': 'Отфильтруйте заявки по их статусу.',
  'tooltip.tableBatchId': 'Ссылка на заявку, связанная с заявкой',
  'tooltip.tableState': 'Статус заявки',
  'tooltip.tableUsageAfter': 'Дата начала действия заявки',
  'tooltip.tableUsageUntil': 'Дата истечения срока действия заявки',
  'tooltip.history': 'История платежей ваших заявок.',
  'tooltip.addPerson': 'Добавить нового человека, связанного с вашей учетной записью.',
  'tooltip.urgent': 'Это означает, что заявка помечена как срочная и должна быть обработана как можно скорее.',
  'tooltip.operationId': 'Тип заявки.',
  'tooltip.purposeOfVisit': 'Цель визита для этой заявки.',
  'tooltip.amount': 'Цена этой заявки.',
  'tooltip.paymentType': 'Тип оплаты для этой визовой заявки.',
  'tooltip.paymentReference': 'Ссылка на платеж для этой визовой заявки.',
  'tooltip.review': 'Рассмотрите эту визовую заявку как одобренную или отклоненную и добавьте комментарий.',
  'tooltip.revision': 'Запросите у клиента исправление визовой заявки.',
  'tooltip.approve': 'Одобрите эту визовую заявку в качестве окончательного решения. Вы также можете добавить комментарий. Если присутствует термин "в черном списке", человек будет занесен в черный список.',
  'tooltip.refuse': 'Отклоните эту визовую заявку в качестве окончательного решения. Вы также можете добавить комментарий.',
  'tooltip.qrSee': 'Просмотрите QR-код этой заявки и распечатайте связанный с ней документ.',
  'tooltip.internalEdit': 'Редактировать внутреннюю ссылку этой визовой заявки.',
  'tooltip.internalAdd': 'Добавить внутреннюю ссылку к этой заявке.',
  'tooltip.printApplication': 'Распечатать заявку со всей информацией.',
  'tooltip.allReviews': 'Все обзоры этой визовой заявки с указанием даты и пользователя, который выполнил обзор.',
  'tooltip.version': 'Текущая версия приложения.',
  'tooltip.consumeProfile.IN': 'Фотография, сделанная при въезде.',
  'tooltip.consumeNoProfile.IN': 'Фотография при въезде не сделана.',
  'tooltip.consumeTime.IN': 'Дата и время въезда.',
  'tooltip.consumePlace.IN': 'Место въезда.',
  'tooltip.consumeProfile.OUT': 'Фотография, сделанная при выезде.',
  'tooltip.consumeNoProfile.OUT': 'Фотография при выезде не сделана.',
  'tooltip.consumeTime.OUT': 'Дата и время выезда.',
  'tooltip.consumePlace.OUT': 'Место выезда.',
  'tooltip.passportComparison': 'Информация, отсканированная из паспорта. Это позволяет вам сравнить информацию с фактическими данными заявки.',
  'tooltip.classicComparison': 'Фактическая информация заявки. Это позволяет вам сравнить информацию с отсканированной из паспорта.',
  'tooltip.trackingApplicationReference': 'Ссылка на заявку этих заявок',
  'tooltip.allTrackingInfo': 'Вся информация об этой заявке',
  'tooltip.trackingPrint': 'Распечатать документ, связанный с этой заявкой',
  'tooltip.docFirstName': 'Введите имя человека так, как оно указано в паспорте.',
  'tooltip.docLastName': 'Введите фамилию человека так, как она указана в паспорте.',
  'tooltip.docPassportNumber': 'Введите номер паспорта человека.',
  'tooltip.docLinkType': 'Выберите тип родственной связи с этим человеком.',
  'tooltip.docLinkTypeOther': 'Уточните тип родственной связи с этим человеком.',
  'tooltip.applicationReferenceRequest': 'Ссылка на заявление. Она уникальна для каждого заявления и создается автоматически.',
  'tooltip.portEntryRequest': 'Пункт въезда в заявлении. Это место, через которое человек планирует въехать в страну.',
  'tooltip.otherName': 'Введите другое имя заявителя так, как оно указано в паспорте.',
  'tooltip.spouseCheckbox': 'Отметьте этот флажок, если у заявителя есть супруг, и заполните информацию ниже.',
  'tooltip.hostName': 'Имя человека/организации, которая примет заявителя.',
  'tooltip.scanPassport': 'Сканируйте паспорт заявителя, чтобы найти заявки, связанные с этим паспортом. Если заявки не найдены, вы можете создать новую.',
  'tooltip.passportScanned': 'Информация, отсканированная из паспорта.',
  'tooltip.scannedCard': 'Похожие заявки, найденные с отсканированной информацией.',
  'scan.error': 'Произошла ошибка при сканировании документа.',
  'tooltip.webcamProblems': 'Если камера не работает должным образом, вы все равно можете зарегистрировать или завершить заявку без фотографии.',
  'tooltip.checkOut': 'Вывести человека из страны.',
  'tooltip.checkIn': 'Зарегистрировать человека в стране.',
  'tooltip.consumeRefuse': 'Отклоните въезд или выезд человека.',
  'tooltip.finalRefuse': 'Окончательное решение по заявке. Человек не сможет въехать в страну.',
  'tooltip.finalApprove': 'Окончательное решение по заявке. Человек сможет въехать или выехать из страны.',
  'tooltip.finalPending': 'Окончательное решение по заявке. Человек не сможет въехать в страну, пока заявка не будет исправлена и одобрена.',
  'tooltip.finalRefuseBlacklist': 'Окончательное решение по заявке. Человек не сможет въехать в страну и будет занесен в черный список.',
  'err.ResidencePermitNumber.pattern': 'Номер разрешения на проживание должен содержать только заглавные буквы и цифры',
  'photo.entryCountry.IN': 'Фотография при въезде',
  'supervision.login.error': 'Ошибка проверки супервайзера.',
  'dashboard.noPreviousApplication': 'Предыдущие заявки не найдены',
  'photo.entryCountry.OUT': 'Фотография при выезде',
  'err.noPassiveAuthenticationCSCA': 'Документ действителен, но не может быть проверен у выдающего органа.',
  'err.passport.expired': 'Срок действия паспорта истек.',
  'externalIndexedData': 'Найдено несколько паспортов',
  'client.extended.chargedBack': 'Эта заявка была возвращена. Лицо может продолжить процесс выезда, но оно должно повторно оплатить въездной сбор только наличными.',
  'ask.chargedBack.confirm': 'Подтверждаете ли вы, что человек повторно оплатил въездной сбор? Если вы подтверждаете, пожалуйста, введите ссылку на платеж и используемую валюту.',
  'error.payment.noReferenceChargedBack': 'Пожалуйста, введите ссылку на платеж и используемую валюту.',
  'client.extended.entryChargedBack': 'Эта заявка была возвращена. Лицо не может продолжить процесс регистрации и должно создать новую запись о въезде.',
  'tooltip.syncing': 'Количество процессов заявок, в настоящее время проходящих синхронизацию.',
  'adChoice': 'Подключение к активному каталогу',
  'external.down': 'Служба, от которой зависит наше приложение, в настоящее время не работает. Пожалуйста, попробуйте позже.',
  'global.connection.server': 'Служба недоступна. Извините за неудобства, повторите попытку позже.',
  'global.connection.problem': 'Ошибка загрузки вашего запроса. Пожалуйста, убедитесь, что вы не используете VPN, брандмауэры, что ваше интернет-соединение стабильно, и попробуйте снова.',
  'err.passport.issuedSoon': 'Паспорт был выдан недавно (менее месяца назад).',
  'global.reload': 'Перезагрузить',
  'error.passportScan': 'CertBytes(b64): {certBytes}',
  'glpi.err.noPassiveAuthenticationCSCA': 'Хэш сертификата паспорта не найден в главном списке ИКАО, что привело к ошибке "err.noPassiveAuthenticationCSCA".',
  'glpi.err.unverifiedDoc': 'Не удалось получить байты сертификата для пассивной аутентификации; это приводит к ошибке "err.unverifiedDoc".',
  'glpi.err.noPassiveAuthentication': 'Не удалось выполнить пассивную аутентификацию; это приводит к ошибке "err.noPassiveAuthentication".',
  'glpi.err.noConnect': 'Не удалось установить соединение с чипом паспорта, что привело к ошибке "err.noConnect".',
  'glpi.err.noBAC': 'BAC не удалось установить с предоставленной информацией MRZ, что вызвало ошибку "err.noBAC".',
  'glpi.err.alteredDoc': 'Хеши группы данных (DGS) некорректны для одной или нескольких записей, что приводит к ошибке "err.alteredDoc".',
  'glpi.err.revokedDocSigner': 'Серийный номер сертификата подписавшего документа найден в списке отзыва сертификатов (CRL), что приводит к ошибке "err.revokedDocSigner".',
  'watchlistCollapse': 'Найдены списки наблюдения - {categories}',
  'match.type': 'Тип совпадения',
  'match.hair': 'Цвет волос',
  'match.eyes': 'Цвет глаз',
  'match.height': 'Рост',
  'match.weight': 'Вес',
  'match.race': 'Раса',
  'global.category': 'Категория',
  'watchlist.alertLevel': 'Уровень предупреждения списка наблюдения',
  'watchlist.match': 'Совпадение {numberMatch} | {matchCategory}',
  'Nationalities': 'Гражданство {index}',
  'global.score': 'Оценка',
  'watchlist.name': 'Название списка наблюдения',
  'alias': 'Псевдоним {index}',
  'document.number': 'Номер документа {index}',
  'document.issuer': 'Орган, выдавший документ {index}',
  'document.type': 'Тип документа {index}',
  'dateOfBirth': 'Дата рождения {index}',
  'watchlist.marks': 'Приметы',
  'watchlist.image.link': 'Ссылка на найденное изображение {index}',
  'image.match': 'Совпадение изображения {index}',
  'tooltip.watchlist': 'Информация списка наблюдения, найденная для этого человека.',
  'watchList.category': 'Категория списка наблюдения',
  'watchlist.level': 'Уровень предупреждения',
  'scan.fingerprint.desc': 'Когда будете готовы, нажмите на кнопку ниже, чтобы начать процесс снятия отпечатков пальцев у человека. Человек должен приложить указательный палец к сканеру, когда загорится красный свет устройства для снятия отпечатков пальцев, как указано офицером.',
  'scan.fingerprint.noResponse': 'Нет ответа от сканера отпечатков пальцев. Приложил ли человек палец к сканеру? Устройство правильно подключено?',
  'scan.fingerprint': 'Отпечаток пальца',
  'fingerprint.scan.start': 'Сканировать отпечаток пальца',
  'scan.fingerprint.success': 'Отпечатки пальцев были успешно отсканированы. Качество сканированного отпечатка пальца {quality}/100. Вы можете повторить процесс, если качество недостаточно.',
  'fingerprint.notAvailable': 'Похоже, что сканер отпечатков пальцев недоступен или драйверы не установлены. Вы все равно можете продолжить регистрацию без отпечатков пальцев.',
  'skip': 'Пропустить',
  'global.checkOut.fingerprint': 'Выезд с отпечатком пальца',
  'global.checkIn.fingerprint': 'Регистрация с отпечатком пальца',
  'tooltip.checkOut.fingerprint': 'Вывести человека из страны с отпечатком пальца.',
  'tooltip.checkIn.fingerprint': 'Зарегистрировать человека в стране с отпечатком пальца.',
  'paymentError.title': 'Проблема с вашим заказом',
  'DYN.paymentError.desc.fail': 'К сожалению, платеж не прошел. Пожалуйста, попробуйте снова.',
  'DYN.paymentError.desc.error': 'К сожалению, при обработке платежа произошла ошибка. Пожалуйста, свяжитесь с нами',
  'DYN.paymentError.desc.later': 'К сожалению, обработка платежа была временно отклонена. Пожалуйста, попробуйте снова.',
  'tooltip.applicationId': 'ID заявки.',
  'client.extended.missingResource': 'Запрашиваемый вами ресурс в настоящее время недоступен. Пожалуйста, попробуйте снова позже.',
  'skip.valid': 'Автоматический пропуск рассмотренных шагов',
  'extension.data': 'Данные о продлении',
  'attestantAddress': 'Адрес свидетеля',
  'attestantEmail': 'Электронная почта свидетеля',
  'attestantID': 'ID свидетеля',
  'attestantName': 'Имя свидетеля',
  'attestantPhone': 'Телефон свидетеля',
  'attestantRelation': 'Связь со свидетелем',
  'daysRequested': 'Запрашиваемое количество дней',
  'tooltip.visaApplicationReference': 'Перейти к визовой заявке, связанной с этим запросом на продление',
  'extend.visaReference': 'Заявка, связанная с этим запросом на продление',
  'data.copyOfEntry': 'Копия въезда',
  'data.departureTicket': 'Билет на выезд',
  'data.attestantDocument': 'Документ свидетеля',
  'data.affidavitCustody': 'Заверение о хранении',
  'reasonForExtention': 'Причина продления',
  'final.ZWEVISAEXTAB': 'Этот запрос на продление должен быть одобрен офицером.',
  'zwevisaExtValid': 'Продление подтверждено',
  'zwevisaExtValid.desc': 'Этот запрос на продление был подтвержден офицером.',
  'zwevisaExtC.review.state': 'Ожидание рассмотрения',
  'zwevisaExtC.review.desc': 'Этот запрос на продление ожидает рассмотрения.',
  'zwevisaExtC.finalReview.desc': 'Этот запрос на продление был рассмотрен и в настоящее время ожидает окончательного рассмотрения.',
  'zwevisaExtC.finalReview.state': 'Ожидание окончательного рассмотрения',
  'tooltip.tableLocalUsageUntil': 'Дата истечения срока действия заявки относится к максимальной дате окончания пребывания.',
  'ask.localUsageUntil.confirm': 'Здесь вы можете изменить максимальную дату окончания пребывания. Вы можете только уменьшить дату.',
  'localUsageUntil.ask': 'Изменить максимальную дату окончания пребывания (необязательно)',
  'error.bad.localUsageUntil': 'Максимальная дата окончания пребывания должна быть раньше текущей даты истечения срока действия и после сегодняшнего дня.',
  'none': 'Нет',
  'change.password.ad': 'Имея учетную запись в активном каталоге, вы не можете изменить свой пароль здесь. Для получения дополнительной информации, пожалуйста, свяжитесь с поддержкой.',
  'noticePrint.title': 'Информация о уведомлении посетителя, распечатанная для клиента',
  'reportingPost': 'Пост отчетности',
  'noticePrint.matTooltip': 'Информация о уведомлении посетителя, распечатанная для клиента во время процесса регистрации',
  'notice.confirm': 'Вы уверены в информации в уведомлении?',
  'global.refusePrint': 'Распечатать и отправить',
  'global.nextPrint': 'Распечатать и продолжить',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'Период "с" должен быть до периода "до".',
  'payment.reject_reason': 'Причина отклонения',
  'err.fileSize': 'Размер файла слишком велик. Максимальный размер: {size}',
  'document.zafembpass': 'Паспорт посольства ZAF',
  'preenroll': 'Предварительная регистрация',
  'screen': 'Скрининг',
  'pass': 'Паспорт',
  'document.pass': 'Паспорт',
  'document.screen': 'Скрининг',
  'payment.ask.print': 'Квитанция напечатана?',
  'global.no.retry': 'Нет (повторить)',
  'print.receipt': 'Печать квитанции',
  'tooltip.printReceipt': 'Распечатать квитанцию(и) заявки',
  'ask.printReceipt': 'Хотите распечатать квитанцию от <b>{date}</b>?',
  'error.printReceipt': 'Произошла ошибка при печати квитанции. Попробуйте еще раз.',
  'ask.selectReceipt': 'Пожалуйста, выберите квитанцию для печати.',
  'operation.OUT': 'Выезд',
  'operation.IN': 'Въезд',
  'operation.PAYMENT_FINALIZED': 'Оплата завершена',
  'operation.PAYMENT_CREATED': 'Оплата создана',
  'operation.PAYMENT_USED_FORCE': 'Оплата использована принудительно',
  'noChoice.selectedReceipt': 'Пожалуйста, выберите квитанцию для печати.',
  'select.receipt': 'Выбрать квитанцию',
  'receiptFor.alt': 'Квитанция для',
  'paymentType': 'Тип оплаты',
  'totalAmount.alt': 'Итоговая сумма',
  'totalAmount': 'Итоговая сумма',
  'date': 'Дата',
  'client': 'Клиент',
  'desc': 'Описание',
  'details': 'Детали',
  'client.extended.minUsageNotMet': 'Дата окончания действия должна быть как минимум на 1 день позже даты начала действия.',
  'payment.assigned.warning': 'Эта заявка в настоящее время используется другим офицером (Офицер: {officerId}) менее 24 часов назад. Вы действительно хотите открыть эту заявку?',
  'lock': 'Заблокировать',
  'tooltip.tableLockTitle': 'Активное использование офицером(ами)',
  'client.extended.uuidNotPaid': 'Оплата еще не подтверждена. Пожалуйста, подтвердите оплату перед продолжением.',
  'form.operationComments': 'Обосновать операцию',
  'borderPass.emit': 'Пограничный пропуск выдан',
  'tooltip.borderPass': 'Пограничный пропуск — это документ, который позволяет человеку пересечь границу. Он используется, когда у человека нет паспорта.',
  'zweexit.title': 'Выезд без визы',
  'borderPass.title': 'Пограничный пропуск',
  'print.borderPass': 'Распечатать пограничный пропуск',
  'print.borderPass.ask': 'Пограничный пропуск напечатан?',
  'err.issueDate.afterExpiryDate': 'Дата выдачи должна быть до даты истечения срока действия.',
  'err.BirthDay.afterExpiryDate': 'Дата рождения должна быть до даты истечения срока действия.',
  'err.BirthDay.afterIssueDate': 'Дата рождения должна быть до даты выдачи.',
  'apiPnrCollapse': 'Найден PNR',
  'apipnrResponse.match': 'Совпадение {numberMatch}',
  'match.name': 'Имя',
  'match.score.name': 'Оценка имени',
  'match.flightCarrier': 'Авиаперевозчик',
  'match.flightNumber': 'Номер рейса',
  'match.documentType': 'Тип документа',
  'match.documentNumber': 'Номер документа',
  'match.documentIssuer': 'Эмитент документа',
  'match.timeType': 'Тип события',
  'match.timeDate': 'Дата события',
  'match.timeScope': 'Период события',
  'match.nationality': 'Гражданство',
  'match.gender': 'Пол',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'UUID путешественника',
  'tooltip.apiPnr': 'Информация PNR, найденная для этого человека.',
  'match.documentIssued': 'Дата выдачи документа',
  'match.placeIssued': 'Место выдачи документа',
  'match.documentExpiration': 'Дата истечения срока действия документа',
  'match.documentScore': 'Оценка документа',
  'match.timeScore': 'Оценка события',
  'match.flightOriginDomestic': 'Внутреннее происхождение рейса',
  'match.flightOriginIcao': 'ICAO места отправления рейса',
  'match.flightOriginLat': 'Широта места отправления рейса',
  'match.flightOriginLng': 'Долгота места отправления рейса',
  'match.flightOriginIata': 'IATA места отправления рейса',
  'match.flightOriginCity': 'Город места отправления рейса',
  'match.flightOriginState': 'Штат места отправления рейса',
  'match.flightOriginCountry': 'Страна места отправления рейса',
  'match.flightOriginContinent': 'Континент места отправления рейса',
  'match.flightOriginName': 'Название места отправления рейса',
  'match.flightOriginTimezone': 'Часовой пояс места отправления рейса',
  'match.flightDestinationDomestic': 'Внутреннее назначение рейса',
  'match.flightDestinationIcao': 'ICAO места назначения рейса',
  'match.flightDestinationLat': 'Широта места назначения рейса',
  'match.flightDestinationLng': 'Долгота места назначения рейса',
  'match.flightDestinationIata': 'IATA места назначения рейса',
  'match.flightDestinationCity': 'Город места назначения рейса',
  'match.flightDestinationState': 'Штат места назначения рейса',
  'match.flightDestinationCountry': 'Страна места назначения рейса',
  'match.flightDestinationContinent': 'Континент места назначения рейса',
  'match.flightDestinationName': 'Название места назначения рейса',
  'match.flightDestinationTimezone': 'Часовой пояс места назначения рейса',
  'match.localDepartureDate': 'Местная дата отправления',
  'match.localDepartureTime': 'Местное время отправления',
  'match.localDepartureTotalMinutes': 'Общее количество минут местного отправления',
  'match.localDepartureDay': 'День местного отправления',
  'match.localDepartureZone': 'Зона местного отправления',
  'match.airportDepartureDate': 'Дата отправления из аэропорта',
  'match.airportDepartureTime': 'Время отправления из аэропорта',
  'match.airportDepartureTotalMinutes': 'Общее количество минут отправления из аэропорта',
  'match.airportDepartureDay': 'День отправления из аэропорта',
  'match.airportDepartureZone': 'Зона отправления из аэропорта',
  'match.utcDepartureDate': 'Дата отправления UTC',
  'match.utcDepartureTime': 'Время отправления UTC',
  'match.utcDepartureTotalMinutes': 'Общее количество минут отправления UTC',
  'match.utcDepartureDay': 'День отправления UTC',
  'match.utcDepartureZone': 'Зона отправления UTC',
  'match.originalDeparture': 'Первоначальное отправление',
  'match.flightDepartureUtcstr': 'Отправление рейса по UTC',
  'match.localArrivalDate': 'Местная дата прибытия',
  'match.localArrivalTime': 'Местное время прибытия',
  'match.localArrivalTotalMinutes': 'Общее количество минут местного прибытия',
  'match.localArrivalDay': 'День местного прибытия',
  'match.localArrivalZone': 'Зона местного прибытия',
  'match.airportArrivalDate': 'Дата прибытия в аэропорт',
  'match.airportArrivalTime': 'Время прибытия в аэропорт',
  'match.airportArrivalTotalMinutes': 'Общее количество минут прибытия в аэропорт',
  'match.airportArrivalDay': 'День прибытия в аэропорт',
  'match.airportArrivalZone': 'Зона прибытия в аэропорт',
  'match.utcArrivalDate': 'Дата прибытия UTC',
  'match.utcArrivalTime': 'Время прибытия UTC',
  'match.utcArrivalTotalMinutes': 'Общее количество минут прибытия UTC',
  'match.utcArrivalDay': 'День прибытия UTC',
  'match.utcArrivalZone': 'Зона прибытия UTC',
  'match.originalArrival': 'Первоначальное прибытие',
  'match.flightArrivalUtcstr': 'Прибытие рейса по UTC',
  'match.flightBound': 'Направление рейса',
  'ask.notice': 'Распечатать уведомление посетителю или временное уведомление об ограничении',
  'tooltip.checkIn.notice': 'Въезд человека в страну с печатью уведомления посетителю или временного уведомления об ограничении.',
  'global.checkIn.notice': 'Въезд с уведомлением',
  'event.downgrade': 'Эта заявка была понижена с <b>{previousPayment}</b> до <b>{newPayment}</b> {date} пользователем <b>{userId}</b>.',
  'form.numberPeople': 'Количество людей, путешествующих с заявителем',
  'feedbackForm': 'Форма обратной связи',
  'form.totalSpend': 'Общая сумма расходов за время пребывания',
  'countryPermanentResidence': 'Страна постоянного проживания',
  'form.feedbackComments': 'Дополнительные комментарии',
  'feedback.submit': 'Отправить отзыв',
  'feedback.submitted': 'Отзыв успешно отправлен.',
  'residencePermit.warning': 'Номер вида на жительство <b>{permitNumber}</b> не найден в базе данных.<br><br>Пожалуйста, вручную проверьте этот номер с физическим документом путешественника перед одобрением въезда.',
  'statusLabel.toConfirm': '(требует подтверждения)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'Город рождения',
  'form.eyeColor': 'Цвет глаз',
  'form.hairColor': 'Цвет волос',
  'form.height': 'Рост',
  'form.occupation': 'Род деятельности',
  'form.fatherFirstName': 'Имя отца',
  'form.fatherLastName': 'Фамилия отца',
  'form.motherFirstName': 'Имя матери',
  'form.motherLastName': 'Фамилия матери',
  'form.physical.description': 'Физическое описание',
  'documents.no.documents': 'Документы для этого приложения не найдены',
  'OtherPurpose': 'Другая причина',
  'form.seniority.ownPlace': 'Только для собственного места',
  'form.seniority.allPlaces': 'Все места',
  'tooltip.nextApplication': 'Загрузить следующее заявление, требующее обработки',
  'nextApplication.button': 'Обработать следующее заявление',
  'error.insufficientPermissions': 'Недостаточно прав для доступа к этой функции',
  'nextApplication.noMore': 'Больше нет заявлений для обработки',
  'nextApplication.error': 'Ошибка загрузки следующего заявления',
  'document.Preview': 'Предварительный просмотр',
  'nav.searchFromDocument': 'Поиск по документу',
  'traveller.history.title': 'История путешественника',
  'traveller.history.loading': 'Загрузка истории…',
  'traveller.history.entry_exit': 'Въезд / Выезд',
  'traveller.history.compliance': 'Соответствие',
  'traveller.history.view_more': 'Показать больше',
  'traveller.history.collapse': 'Свернуть',
  'traveller.history.no_records': 'Записи не найдены',
  'traveller.history.records': 'записей',
  'traveller.history.user': 'Пользователь',
  'traveller.history.reason': 'Причина',
  'traveller.history.additional_info': 'Дополнительная информация',
  'traveller.history.event.ENTERED_COUNTRY': 'Въезд в страну',
  'traveller.history.event.EXITED_COUNTRY': 'Выезд из страны',
  'traveller.history.event.DEPORTATION_CREATED': 'Депортация создана',
  'traveller.history.event.DEPORTATION_EDITED': 'Депортация изменена',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'Депортация одобрена руководителем',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'Депортация одобрена дир. по операциям',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'Успешно депортирован',
  'traveller.history.event.DEPORTATION_DECLINED': 'Депортация отклонена',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'Добавлен в список наблюдения',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'Удалён из списка наблюдения',
  'traveller.history.event.PROSECUTION_CREATED': 'Судебное преследование создано',
  'traveller.history.event.ADDED_BIOMETRIC': 'Биометрия добавлена',
  'traveller.history.event.INTERVIEW_CREATED': 'Интервью создано',
  'traveller.history.event.INTERVIEW_EDITED': 'Интервью изменено',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'Запись беженца создана',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'Запись беженца изменена',
  'traveller.history.visa': 'Виза',
  'traveller.history.event.VALIDATED': 'Одобрена',
  'traveller.history.event.REFUSED': 'Отказано',
  'traveller.history.permits': 'Разрешения',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'Обычное разрешение на проживание',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'Разрешение на проживание супруга',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'Разрешение на проживание инвестора',
  'traveller.history.permit.STUDENTS_PERMIT': 'Студенческое разрешение',
  'traveller.history.permit.SCHOLARS_PERMIT': 'Школьное разрешение',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'Временное разрешение на работу',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'Разрешение на работу',
  'traveller.history.permit.RESUMPTION': 'Возобновление',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'Двойное гражданство',
  'traveller.history.permit.REINSTATEMENT': 'Восстановление',
  'traveller.history.permit.applicationType': 'Тип заявки',
  'traveller.history.permit.appType.INITIAL': 'Первичная',
  'traveller.history.permit.appType.EXTENSION': 'Продление',
  'traveller.history.permit.appType.PERMANENT': 'Постоянная',
  'traveller.history.permit.status.REQUESTED': 'Запрошено',
  'traveller.history.permit.status.APPROVED': 'Одобрено',
  'traveller.history.permit.status.REJECTED': 'Отклонено',
  'traveller.history.permit.issueDate': 'Дата выдачи',
  'traveller.history.permit.expiryDate': 'Дата истечения',
  'showcase.heroTitle': 'Быстро, безопасно & <em>цифровой</em><br/>опыт eVisa.',
  'showcase.heroSubtitle': 'Подайте заявку, пройдите проверку и путешествуйте за минуты. {name} сочетает биометрическую идентификацию с государственной системой принятия решений — чтобы ваше одобрение пришло раньше вас.',
  'showcase.heroSubtitle.evisa': 'Подайте заявку, пройдите проверку и путешествуйте за минуты. {name} сочетает биометрическую идентификацию с государственной системой принятия решений — чтобы ваше одобрение пришло раньше вас.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'Подайте заявку на паспорт, удостоверение личности или вид на жительство онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени, от подачи до выдачи.',
  'showcase.heroSubtitle.passport_idCard': 'Подайте заявку на паспорт или удостоверение личности онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroSubtitle.passport': 'Подайте заявку на паспорт онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroSubtitle.idCard': 'Подайте заявку на удостоверение личности онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroSubtitle.residencePermit': 'Подайте заявку на вид на жительство онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroSubtitle.passport_residencePermit': 'Подайте заявку на паспорт или вид на жительство онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroSubtitle.idCard_residencePermit': 'Подайте заявку на удостоверение личности или вид на жительство онлайн. {name} обрабатывает и отслеживает каждую заявку в реальном времени.',
  'showcase.heroCta1': 'Подать заявку на eVisa',
  'showcase.heroCta2': 'Отследить заявку',
  'showcase.flowTitleMain': 'Четыре шага.<br/><em>Ноль очередей.</em>',
  'showcase.flowTitleSub': 'Заявка, которая путешествует вместе с вами.',
  'showcase.flowSubtitle': '{name} организует четыре этапа вашей заявки в единое плавное движение, система занимается документами, пока вы собираете чемодан.',
  'showcase.ctaTitle': 'Начните своё путешествие<br/><em>в цифровом формате.</em>',
  'showcase.ctaSubtitle': 'Одна заявка. eVisa в вашем кармане и решение, которое придёт раньше вас.',
  'showcase.step1.label': 'Создать заявку',
  'showcase.step1.paneTitle': 'Заполните данные',
  'showcase.step1.paneDesc': 'Место назначения, даты поездки, цель визита и пункт въезда…',
  'showcase.step2.label': 'Загрузить документы',
  'showcase.step2.paneTitle': 'Загрузите паспорт',
  'showcase.step2.paneDesc': 'Скан паспорта, считывание МРЗ, мгновенное извлечение данных…',
  'showcase.step3.label': 'Биометрическая верификация',
  'showcase.step3.paneTitle': 'Проверка живости & сопоставление лиц',
  'showcase.step3.paneDesc': 'Проверка живости, сопоставление лиц и проверка санкций…',
  'showcase.step4.label': 'Мгновенное одобрение',
  'showcase.step4.paneTitle': 'Одобрено & готово к пересечению границы',
  'showcase.step4.paneDesc': 'Ваша eVisa подписана, защищена и синхронизирована с вашим кошельком…',
  'showcase.stat1.value': 'Зашифровано',
  'showcase.stat1.label': 'сквозное',
  'showcase.stat2.value': 'Сертифицировано',
  'showcase.stat2.label': 'безопасная платформа',
  'showcase.portalType': 'Портал eVisa',
  'showcase.tl.step1': 'Личность',
  'showcase.tl.step3': 'Решение',
  'showcase.tl.step4': 'Путешествие',
  'showcase.tl.step2': 'Документы',
  'showcase.evisa.ministry': 'МИНИСТЕРСТВО ИНОСТРАННЫХ ДЕЛ',
  'showcase.marquee.issuedBy': 'Выдано суверенными органами',
  'showcase.marquee.biometric': 'Биометрика',
  'showcase.marquee.secured': 'Защищено',
  'showcase.marquee.borderReady': 'Готово к пересечению границы за минуты',
  'showcase.marquee.encrypted': 'Сквозное шифрование',
  'showcase.marquee.eSeal': 'Квалифицированная электронная печать',
  'showcase.marquee.realtime': 'Отслеживание в реальном времени',
  'showcase.annot.mrz': 'МРЗ верифицирован',
  'showcase.annot.biometric': 'Биометрика',
  'showcase.annot.issued': 'Выдано',
  'showcase.annot.secured': 'Защищено',
  'showcase.howItWorks': 'Как это работает',
  'showcase.signIn': 'Войти в мой аккаунт',
  'showcase.scroll': 'Прокрутить',
  'showcase.permit.badge': 'РЕЗИДЕНТ',
  'showcase.permit.title': 'РАЗРЕШЕНИЕ',
  'showcase.permit.name': 'Вид на жительство',
  'finger.thumb': 'Большой',
  'finger.index': 'Указательный',
  'finger.middle': 'Средний',
  'finger.ring': 'Безымянный',
  'finger.little': 'Мизинец',
  'finger.missing': 'Отсутствует',
  'hand.left': 'Левая рука',
  'hand.right': 'Правая рука',
  'fingerprints': 'Отпечатки пальцев',
  'finger.thumbs': 'Большие пальцы',
  'fingers.missing': 'Отсутствующие пальцы',
  'signature': 'Подпись',
  'print.withdrawal.date': 'Дата изъятия',
  'trips.helper': 'Нажмите, чтобы просмотреть/скачать QR-код'
};
